/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCategory
// ====================================================

export interface CreateCategory_createCategory_parent {
  __typename: "Category";
  /**
   * The public ID, an UUID v4
   */
  id: string;
}

export interface CreateCategory_createCategory {
  __typename: "Category";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  label: string | null;
  parent: CreateCategory_createCategory_parent | null;
}

export interface CreateCategory {
  /**
   * Create a single "Category" node.
   */
  createCategory: CreateCategory_createCategory;
}

export interface CreateCategoryVariables {
  data: CategoryCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreatePhoto
// ====================================================

export interface CreatePhoto_createPhoto_archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  /**
   * get the access rights of the archive
   */
  accesses: (string | null)[] | null;
}

export interface CreatePhoto_createPhoto_previews {
  __typename: "Preview";
  href: string | null;
  size: number | null;
}

export interface CreatePhoto_createPhoto_photoMetadatas_metadata {
  __typename: "Metadata";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  name: MetadataNameEnumType;
}

export interface CreatePhoto_createPhoto_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
  metadata: CreatePhoto_createPhoto_photoMetadatas_metadata;
}

export interface CreatePhoto_createPhoto {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  archive: CreatePhoto_createPhoto_archive;
  /**
   * The date, fixed, of the document's creation
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update
   */
  updatedAt: GraphQL$DateTime;
  originalName: string | null;
  /**
   * asset content type
   */
  contentType: string | null;
  /**
   * get a S3 download URL
   */
  downloadUrl: string | null;
  /**
   * get all supported resized previews
   */
  previews: CreatePhoto_createPhoto_previews[] | null;
  /**
   * "PhotoMetadata.photo"'s inverse relation
   */
  photoMetadatas: CreatePhoto_createPhoto_photoMetadatas[];
  /**
   * get presigned url from S3
   */
  uploadUrl: string | null;
}

export interface CreatePhoto {
  /**
   * Create a single "Photo" node.
   */
  createPhoto: CreatePhoto_createPhoto;
}

export interface CreatePhotoVariables {
  data: PhotoCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePhoto
// ====================================================

export interface UpdatePhoto_updatePhoto_archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  /**
   * get the access rights of the archive
   */
  accesses: (string | null)[] | null;
}

export interface UpdatePhoto_updatePhoto_previews {
  __typename: "Preview";
  href: string | null;
  size: number | null;
}

export interface UpdatePhoto_updatePhoto_photoMetadatas_metadata {
  __typename: "Metadata";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  name: MetadataNameEnumType;
}

export interface UpdatePhoto_updatePhoto_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
  metadata: UpdatePhoto_updatePhoto_photoMetadatas_metadata;
}

export interface UpdatePhoto_updatePhoto {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  archive: UpdatePhoto_updatePhoto_archive;
  /**
   * The date, fixed, of the document's creation
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update
   */
  updatedAt: GraphQL$DateTime;
  originalName: string | null;
  /**
   * asset content type
   */
  contentType: string | null;
  /**
   * get a S3 download URL
   */
  downloadUrl: string | null;
  /**
   * get all supported resized previews
   */
  previews: UpdatePhoto_updatePhoto_previews[] | null;
  /**
   * "PhotoMetadata.photo"'s inverse relation
   */
  photoMetadatas: UpdatePhoto_updatePhoto_photoMetadatas[];
}

export interface UpdatePhoto {
  /**
   * Update a single "Photo" node.
   */
  updatePhoto: UpdatePhoto_updatePhoto | null;
}

export interface UpdatePhotoVariables {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeletePhoto
// ====================================================

export interface DeletePhoto_deletePhoto {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
}

export interface DeletePhoto {
  /**
   * Delete a single "Photo" node.
   */
  deletePhoto: DeletePhoto_deletePhoto | null;
}

export interface DeletePhotoVariables {
  where: PhotoWhereUniqueInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePhotoFile
// ====================================================

export interface UpdatePhotoFile_updatePhotoFile_archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  /**
   * get the access rights of the archive
   */
  accesses: (string | null)[] | null;
}

export interface UpdatePhotoFile_updatePhotoFile_previews {
  __typename: "Preview";
  href: string | null;
  size: number | null;
}

export interface UpdatePhotoFile_updatePhotoFile_photoMetadatas_metadata {
  __typename: "Metadata";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  name: MetadataNameEnumType;
}

export interface UpdatePhotoFile_updatePhotoFile_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
  metadata: UpdatePhotoFile_updatePhotoFile_photoMetadatas_metadata;
}

export interface UpdatePhotoFile_updatePhotoFile {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  archive: UpdatePhotoFile_updatePhotoFile_archive;
  /**
   * The date, fixed, of the document's creation
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update
   */
  updatedAt: GraphQL$DateTime;
  originalName: string | null;
  /**
   * asset content type
   */
  contentType: string | null;
  /**
   * get a S3 download URL
   */
  downloadUrl: string | null;
  /**
   * get all supported resized previews
   */
  previews: UpdatePhotoFile_updatePhotoFile_previews[] | null;
  /**
   * "PhotoMetadata.photo"'s inverse relation
   */
  photoMetadatas: UpdatePhotoFile_updatePhotoFile_photoMetadatas[];
}

export interface UpdatePhotoFile {
  /**
   * Update files metadatas
   */
  updatePhotoFile: UpdatePhotoFile_updatePhotoFile | null;
}

export interface UpdatePhotoFileVariables {
  photoId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetArchives
// ====================================================

export interface GetArchives_archives {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  /**
   * The historical archiveId provided by Photoware
   */
  archiveId: number;
  /**
   * get the type of the archive
   */
  type: ArchiveType | null;
  /**
   * get the title of the archive
   */
  title: string | null;
  /**
   * get the title of the archive
   */
  key: ArchiveKeyType | null;
  /**
   * get the access rights of the archive
   */
  accesses: (string | null)[] | null;
  /**
   * get the type of the archive
   */
  hasCategory: boolean | null;
}

export interface GetArchives {
  /**
   * Retrieve a list of "Archive" nodes.
   */
  archives: GetArchives_archives[];
}

export interface GetArchivesVariables {
  where?: ArchiveWhereInput | null;
  first: number;
  orderBy?: ArchiveOrderByInput[] | null;
  skip?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCategories
// ====================================================

export interface GetCategories_categories_parent {
  __typename: "Category";
  /**
   * The public ID, an UUID v4
   */
  id: string;
}

export interface GetCategories_categories {
  __typename: "Category";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  label: string | null;
  parent: GetCategories_categories_parent | null;
}

export interface GetCategories {
  /**
   * Retrieve a list of "Category" nodes.
   */
  categories: GetCategories_categories[];
}

export interface GetCategoriesVariables {
  where?: CategoryWhereInput | null;
  first: number;
  orderBy?: CategoryOrderByInput[] | null;
  skip?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPhotoMetadatas
// ====================================================

export interface GetPhotoMetadatas_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
}

export interface GetPhotoMetadatas {
  /**
   * Retrieve a list of "PhotoMetadata" nodes.
   */
  photoMetadatas: GetPhotoMetadatas_photoMetadatas[];
}

export interface GetPhotoMetadatasVariables {
  where?: PhotoMetadataWhereInput | null;
  first: number;
  orderBy?: PhotoMetadataOrderByInput[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SearchPhotos
// ====================================================

export interface SearchPhotos_searchPhotos_archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  /**
   * get the access rights of the archive
   */
  accesses: (string | null)[] | null;
}

export interface SearchPhotos_searchPhotos_previews {
  __typename: "Preview";
  href: string | null;
  size: number | null;
}

export interface SearchPhotos_searchPhotos_photoMetadatas_metadata {
  __typename: "Metadata";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  name: MetadataNameEnumType;
}

export interface SearchPhotos_searchPhotos_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
  metadata: SearchPhotos_searchPhotos_photoMetadatas_metadata;
}

export interface SearchPhotos_searchPhotos {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  archive: SearchPhotos_searchPhotos_archive;
  /**
   * The date, fixed, of the document's creation
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update
   */
  updatedAt: GraphQL$DateTime;
  originalName: string | null;
  /**
   * asset content type
   */
  contentType: string | null;
  /**
   * get a S3 download URL
   */
  downloadUrl: string | null;
  /**
   * get all supported resized previews
   */
  previews: SearchPhotos_searchPhotos_previews[] | null;
  /**
   * "PhotoMetadata.photo"'s inverse relation
   */
  photoMetadatas: SearchPhotos_searchPhotos_photoMetadatas[];
}

export interface SearchPhotos {
  /**
   * optimized for speed search photos query
   */
  searchPhotos: SearchPhotos_searchPhotos[];
}

export interface SearchPhotosVariables {
  where?: PhotoWhereInput | null;
  first: number;
  orderBy?: PhotoOrderByInput[] | null;
  skip?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPhotosCount
// ====================================================

export interface GetPhotosCount {
  /**
   * optimized for speed photos count query
   */
  photoCount: number;
}

export interface GetPhotosCountVariables {
  where?: PhotoWhereInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Archive
// ====================================================

export interface Archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  /**
   * The historical archiveId provided by Photoware
   */
  archiveId: number;
  /**
   * get the type of the archive
   */
  type: ArchiveType | null;
  /**
   * get the title of the archive
   */
  title: string | null;
  /**
   * get the title of the archive
   */
  key: ArchiveKeyType | null;
  /**
   * get the access rights of the archive
   */
  accesses: (string | null)[] | null;
  /**
   * get the type of the archive
   */
  hasCategory: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Category
// ====================================================

export interface Category_parent {
  __typename: "Category";
  /**
   * The public ID, an UUID v4
   */
  id: string;
}

export interface Category {
  __typename: "Category";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  label: string | null;
  parent: Category_parent | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Photo
// ====================================================

export interface Photo_archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  /**
   * get the access rights of the archive
   */
  accesses: (string | null)[] | null;
}

export interface Photo_previews {
  __typename: "Preview";
  href: string | null;
  size: number | null;
}

export interface Photo_photoMetadatas_metadata {
  __typename: "Metadata";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  name: MetadataNameEnumType;
}

export interface Photo_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
  metadata: Photo_photoMetadatas_metadata;
}

export interface Photo {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  archive: Photo_archive;
  /**
   * The date, fixed, of the document's creation
   */
  createdAt: GraphQL$DateTime;
  /**
   * The date of the document's last update
   */
  updatedAt: GraphQL$DateTime;
  originalName: string | null;
  /**
   * asset content type
   */
  contentType: string | null;
  /**
   * get a S3 download URL
   */
  downloadUrl: string | null;
  /**
   * get all supported resized previews
   */
  previews: Photo_previews[] | null;
  /**
   * "PhotoMetadata.photo"'s inverse relation
   */
  photoMetadatas: Photo_photoMetadatas[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ArchiveKeyType {
  CAM_LIVRAISON = "CAM_LIVRAISON",
  CAM_SUJETS = "CAM_SUJETS",
  CLE_SUJETS = "CLE_SUJETS",
  FATV_SUJETS = "FATV_SUJETS",
  GALA_LIVRAISON = "GALA_LIVRAISON",
  HBZ_ARCHIVE = "HBZ_ARCHIVE",
  HBZ_LIVRAISON = "HBZ_LIVRAISON",
  HBZ_SUJETS = "HBZ_SUJETS",
  MAD_SUJETS = "MAD_SUJETS",
  NEON_SUJETS = "NEON_SUJETS",
  NGE_ARCHIVE = "NGE_ARCHIVE",
  NGE_SUJETS = "NGE_SUJETS",
  PECO_LIVRAISON = "PECO_LIVRAISON",
  PECO_SUJETS = "PECO_SUJETS",
  PECO_WEB = "PECO_WEB",
  PFEM_LIVRAISON = "PFEM_LIVRAISON",
  PFEM_SUJETS = "PFEM_SUJETS",
  PGAL_SUJETS = "PGAL_SUJETS",
  PGEO_SUJETS = "PGEO_SUJETS",
  PTVS_ARCHIVES_TV = "PTVS_ARCHIVES_TV",
  PTVS_LIVRAISON = "PTVS_LIVRAISON",
  PTVS_SUJETS = "PTVS_SUJETS",
  TEST_UNIT = "TEST_UNIT",
  TRV_CUI = "TRV_CUI",
  TRV_PHOTOS = "TRV_PHOTOS",
  VOICI_LIVRAISON = "VOICI_LIVRAISON",
  VOICI_SUJETS = "VOICI_SUJETS",
  VOI_ARCHIVES = "VOI_ARCHIVES",
  VOI_BASE_PEOPLE = "VOI_BASE_PEOPLE",
  VOI_BEAUTE = "VOI_BEAUTE",
  VOI_MODE = "VOI_MODE",
}

export enum ArchiveOrderByInput {
  _id_ASC = "_id_ASC",
  _id_DESC = "_id_DESC",
  archiveId_ASC = "archiveId_ASC",
  archiveId_DESC = "archiveId_DESC",
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  updatedAt_ASC = "updatedAt_ASC",
  updatedAt_DESC = "updatedAt_DESC",
}

export enum ArchiveType {
  ARCHIVE = "ARCHIVE",
  DELIVERY = "DELIVERY",
  NEWS = "NEWS",
  SUJET = "SUJET",
}

export enum CategoryOrderByInput {
  _id_ASC = "_id_ASC",
  _id_DESC = "_id_DESC",
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  label_ASC = "label_ASC",
  label_DESC = "label_DESC",
  updatedAt_ASC = "updatedAt_ASC",
  updatedAt_DESC = "updatedAt_DESC",
}

export enum GeneratePreviewSessionStatusType {
  FAILED = "FAILED",
  FINISHED = "FINISHED",
  INTERRUPTED = "INTERRUPTED",
  PENDING = "PENDING",
  RUNNING = "RUNNING",
}

export enum MetadataNameEnumType {
  AccessRights = "AccessRights",
  AddlModelInfo = "AddlModelInfo",
  Archive_child = "Archive_child",
  Archive_parent = "Archive_parent",
  AssetState = "AssetState",
  Audience = "Audience",
  AuthorsPosition = "AuthorsPosition",
  BackupName = "BackupName",
  BitmapGrayscalePicture = "BitmapGrayscalePicture",
  Brand = "Brand",
  BrandPrisma = "BrandPrisma",
  BrandShortName = "BrandShortName",
  CaptionWriter = "CaptionWriter",
  Category = "Category",
  CategoryPrisma = "CategoryPrisma",
  Certificate = "Certificate",
  CiAdrCity = "CiAdrCity",
  CiAdrCtry = "CiAdrCtry",
  CiAdrExtadr = "CiAdrExtadr",
  CiAdrPcode = "CiAdrPcode",
  CiAdrRegion = "CiAdrRegion",
  CiEmailWork = "CiEmailWork",
  CiTelWork = "CiTelWork",
  CiUrlWork = "CiUrlWork",
  City = "City",
  Classify = "Classify",
  Company = "Company",
  CompanyShortName = "CompanyShortName",
  Confidentiality = "Confidentiality",
  ContainedIn = "ContainedIn",
  ContentMediaKind = "ContentMediaKind",
  ContentValue = "ContentValue",
  CopyrightLayer = "CopyrightLayer",
  Country = "Country",
  CountryCode = "CountryCode",
  CreatedTime = "CreatedTime",
  CreatorTool = "CreatorTool",
  Credit = "Credit",
  CustomField14 = "CustomField14",
  CustomField15 = "CustomField15",
  CustomField16 = "CustomField16",
  CustomField17 = "CustomField17",
  CustomField20 = "CustomField20",
  CustomField5 = "CustomField5",
  CustomField9 = "CustomField9",
  DateCreated = "DateCreated",
  DateTimeDigitized = "DateTimeDigitized",
  DateTimeOriginal = "DateTimeOriginal",
  DeliveryAccount = "DeliveryAccount",
  DeliveryCompany = "DeliveryCompany",
  DeliveryCopyright = "DeliveryCopyright",
  DeliveryDateFolder = "DeliveryDateFolder",
  DeliveryDateTime = "DeliveryDateTime",
  DeliveryDcCreator = "DeliveryDcCreator",
  DeliveryDcRights = "DeliveryDcRights",
  DeliveryFileType = "DeliveryFileType",
  DeliveryFolder = "DeliveryFolder",
  DeliveryKind = "DeliveryKind",
  DeliveryPath = "DeliveryPath",
  DeliveryPersonShownintheImage = "DeliveryPersonShownintheImage",
  DeliveryPhotoshopCredit = "DeliveryPhotoshopCredit",
  DeliveryPhotoshopSource = "DeliveryPhotoshopSource",
  DeliveryService = "DeliveryService",
  DeliverySubject = "DeliverySubject",
  DeliveryUnderSubject = "DeliveryUnderSubject",
  Department = "Department",
  DigitalAssetURL = "DigitalAssetURL",
  Division = "Division",
  DocumentText = "DocumentText",
  EditStatus = "EditStatus",
  Edition = "Edition",
  EditorialVersion = "EditorialVersion",
  EnvironnementPhoto = "EnvironnementPhoto",
  EquipmentInstitution = "EquipmentInstitution",
  EquipmentManufacturer = "EquipmentManufacturer",
  Event = "Event",
  Exif = "Exif",
  FabStorage = "FabStorage",
  FileCheckFor = "FileCheckFor",
  FileInfoBitsPerPixel = "FileInfoBitsPerPixel",
  FileInfoFrames = "FileInfoFrames",
  FileInfoImageHeight = "FileInfoImageHeight",
  FileInfoImageWidth = "FileInfoImageWidth",
  FileInfoPhotometricInterpretation = "FileInfoPhotometricInterpretation",
  FileInfoTransferSyntax = "FileInfoTransferSyntax",
  FileStage = "FileStage",
  FileStatus = "FileStatus",
  FileType = "FileType",
  FixtureIdentifier = "FixtureIdentifier",
  Format = "Format",
  GPSLatitude = "GPSLatitude",
  GPSLongitude = "GPSLongitude",
  GPSProcessingMethod = "GPSProcessingMethod",
  Header = "Header",
  HeaderPrisma = "HeaderPrisma",
  Headline = "Headline",
  History = "History",
  ICCProfile = "ICCProfile",
  ID_subject = "ID_subject",
  ISOSpeedRatings = "ISOSpeedRatings",
  IdAssignment = "IdAssignment",
  IdMediaContent = "IdMediaContent",
  IdPhotoPrisma = "IdPhotoPrisma",
  ImageNotes = "ImageNotes",
  ImageUniqueID = "ImageUniqueID",
  Instructions = "Instructions",
  IntellectualGenre = "IntellectualGenre",
  Issue = "Issue",
  JobId = "JobId",
  JobProcessing = "JobProcessing",
  LayoutPictureEditing = "LayoutPictureEditing",
  LayoutStorage = "LayoutStorage",
  Links = "Links",
  LocalCaption = "LocalCaption",
  Location = "Location",
  Make = "Make",
  Manifest = "Manifest",
  Marked = "Marked",
  MasterDocumentId = "MasterDocumentId",
  MaxAvailHeight = "MaxAvailHeight",
  MaxAvailWidth = "MaxAvailWidth",
  MinorModelAgeDisclosure = "MinorModelAgeDisclosure",
  Model = "Model",
  ModelAge = "ModelAge",
  ModelReleaseID = "ModelReleaseID",
  ModelReleaseStatus = "ModelReleaseStatus",
  ObjectCycle = "ObjectCycle",
  OrganisationInImageName = "OrganisationInImageName",
  OriginalColor = "OriginalColor",
  OriginalICCProfile = "OriginalICCProfile",
  OriginalName = "OriginalName",
  OriginalWeigth = "OriginalWeigth",
  Owner = "Owner",
  OwnerId = "OwnerId",
  Page = "Page",
  PagePrisma = "PagePrisma",
  PaintBasedCorrections = "PaintBasedCorrections",
  PatientDOB = "PatientDOB",
  PatientID = "PatientID",
  PatientName = "PatientName",
  PatientSex = "PatientSex",
  PersonInImage = "PersonInImage",
  PhotoStorage = "PhotoStorage",
  PrepressPictureEditing = "PrepressPictureEditing",
  PriceLevel = "PriceLevel",
  PrintingProfile = "PrintingProfile",
  PrismaProduction = "PrismaProduction",
  ProcessHistory = "ProcessHistory",
  ProcessParameter = "ProcessParameter",
  ProcessStatus = "ProcessStatus",
  Product = "Product",
  ProductShortName = "ProductShortName",
  Products = "Products",
  Produits = "Produits",
  ProgramVersion = "ProgramVersion",
  PropertyReleaseID = "PropertyReleaseID",
  PropertyReleaseStatus = "PropertyReleaseStatus",
  Publisher = "Publisher",
  QualifiedUsePrismaBy = "QualifiedUsePrismaBy",
  QualifiedUsePrismaDate = "QualifiedUsePrismaDate",
  QualifiedUsePrismaDuration = "QualifiedUsePrismaDuration",
  QualifiedUsePrismaSupport = "QualifiedUsePrismaSupport",
  Rating = "Rating",
  ReferenceDate = "ReferenceDate",
  ReferenceNumber = "ReferenceNumber",
  ReferenceService = "ReferenceService",
  ReleaseDate = "ReleaseDate",
  ReleaseTime = "ReleaseTime",
  RequiredPermission = "RequiredPermission",
  ResolutionKind = "ResolutionKind",
  Royaltyfree = "Royaltyfree",
  Scene = "Scene",
  Section = "Section",
  SentTo = "SentTo",
  SerialNumber = "SerialNumber",
  SeriesDateTime = "SeriesDateTime",
  SeriesDescription = "SeriesDescription",
  SeriesModality = "SeriesModality",
  SeriesNumber = "SeriesNumber",
  ShortUniqueId = "ShortUniqueId",
  Source = "Source",
  State = "State",
  StudyDateTime = "StudyDateTime",
  StudyDescription = "StudyDescription",
  StudyID = "StudyID",
  StudyPhysician = "StudyPhysician",
  SubjectCode = "SubjectCode",
  SubjectPrisma = "SubjectPrisma",
  SupplementalCategories = "SupplementalCategories",
  TargetVersion = "TargetVersion",
  ToneCurve = "ToneCurve",
  TransferredBy = "TransferredBy",
  TransferredByEmail = "TransferredByEmail",
  TransferredByFullName = "TransferredByFullName",
  TransmissionReference = "TransmissionReference",
  Type = "Type",
  UnderUnderSubject = "UnderUnderSubject",
  Undersubject = "Undersubject",
  UniqueId = "UniqueId",
  Unit = "Unit",
  UnitShortName = "UnitShortName",
  UploadTime = "UploadTime",
  UploadedBy = "UploadedBy",
  UploadedByFullName = "UploadedByFullName",
  Urgency = "Urgency",
  UsageTerms = "UsageTerms",
  UserComment = "UserComment",
  UserDefined195 = "UserDefined195",
  UserDefined237 = "UserDefined237",
  UserDefined238 = "UserDefined238",
  UserDefined239 = "UserDefined239",
  UserDefined242 = "UserDefined242",
  UserDefined62 = "UserDefined62",
  Valid = "Valid",
  Version = "Version",
  WebStatement = "WebStatement",
  WorkflowKind = "WorkflowKind",
  XMPFileStamps = "XMPFileStamps",
  XMPHistory = "XMPHistory",
  attributionName = "attributionName",
  attributionURL = "attributionURL",
  creator = "creator",
  description = "description",
  filesize = "filesize",
  license = "license",
  morePermissions = "morePermissions",
  publishingIssue = "publishingIssue",
  publishingSubject = "publishingSubject",
  rights = "rights",
  subject = "subject",
  title = "title",
}

export enum MetadataValueTypeEnum {
  Date = "Date",
  List = "List",
  Text = "Text",
}

export enum PhotoMetadataOrderByInput {
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  updatedAt_ASC = "updatedAt_ASC",
  updatedAt_DESC = "updatedAt_DESC",
  value_ASC = "value_ASC",
  value_DESC = "value_DESC",
}

export enum PhotoOrderByInput {
  _id_ASC = "_id_ASC",
  _id_DESC = "_id_DESC",
  contentType_ASC = "contentType_ASC",
  contentType_DESC = "contentType_DESC",
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  isLegacy_ASC = "isLegacy_ASC",
  isLegacy_DESC = "isLegacy_DESC",
  isUploaded_ASC = "isUploaded_ASC",
  isUploaded_DESC = "isUploaded_DESC",
  originalName_ASC = "originalName_ASC",
  originalName_DESC = "originalName_DESC",
  updatedAt_ASC = "updatedAt_ASC",
  updatedAt_DESC = "updatedAt_DESC",
}

export interface ArchiveCreateInput {
  id?: string | null;
  archiveId: number;
  categories?: ArchiveNestedCategoriesCreateInput | null;
  photos?: ArchiveNestedPhotosCreateInput | null;
  photoMetadatas?: ArchiveNestedPhotoMetadatasCreateInput | null;
  photoMetadatas1?: ArchiveNestedPhotoMetadatas1CreateInput | null;
  photoMetadatas2?: ArchiveNestedPhotoMetadatas2CreateInput | null;
  photoMetadatas3?: ArchiveNestedPhotoMetadatas3CreateInput | null;
  photoMetadatas4?: ArchiveNestedPhotoMetadatas4CreateInput | null;
  photoMetadatas5?: ArchiveNestedPhotoMetadatas5CreateInput | null;
  photoMetadatas5001?: ArchiveNestedPhotoMetadatas5001CreateInput | null;
  photoMetadatas5012?: ArchiveNestedPhotoMetadatas5012CreateInput | null;
  photoMetadatas5017?: ArchiveNestedPhotoMetadatas5017CreateInput | null;
  photoMetadatas5019?: ArchiveNestedPhotoMetadatas5019CreateInput | null;
  photoMetadatas5020?: ArchiveNestedPhotoMetadatas5020CreateInput | null;
  photoMetadatas5025?: ArchiveNestedPhotoMetadatas5025CreateInput | null;
  photoMetadatas5032?: ArchiveNestedPhotoMetadatas5032CreateInput | null;
  photoMetadatas5033?: ArchiveNestedPhotoMetadatas5033CreateInput | null;
  photoMetadatas5034?: ArchiveNestedPhotoMetadatas5034CreateInput | null;
  photoMetadatas5036?: ArchiveNestedPhotoMetadatas5036CreateInput | null;
  photoMetadatas5037?: ArchiveNestedPhotoMetadatas5037CreateInput | null;
  photoMetadatas5038?: ArchiveNestedPhotoMetadatas5038CreateInput | null;
  photoMetadatas5039?: ArchiveNestedPhotoMetadatas5039CreateInput | null;
  photoMetadatas5040?: ArchiveNestedPhotoMetadatas5040CreateInput | null;
  photoMetadatas5041?: ArchiveNestedPhotoMetadatas5041CreateInput | null;
  photoMetadatas5043?: ArchiveNestedPhotoMetadatas5043CreateInput | null;
  photoMetadatas5044?: ArchiveNestedPhotoMetadatas5044CreateInput | null;
  photoMetadatas5048?: ArchiveNestedPhotoMetadatas5048CreateInput | null;
  photoMetadatas5050?: ArchiveNestedPhotoMetadatas5050CreateInput | null;
  photoMetadatas5051?: ArchiveNestedPhotoMetadatas5051CreateInput | null;
  photoMetadatas5052?: ArchiveNestedPhotoMetadatas5052CreateInput | null;
  photoMetadatas5053?: ArchiveNestedPhotoMetadatas5053CreateInput | null;
  photoMetadatas5054?: ArchiveNestedPhotoMetadatas5054CreateInput | null;
  photoMetadatas5055?: ArchiveNestedPhotoMetadatas5055CreateInput | null;
  photoMetadatas5056?: ArchiveNestedPhotoMetadatas5056CreateInput | null;
  photoMetadatas5057?: ArchiveNestedPhotoMetadatas5057CreateInput | null;
}

export interface ArchiveNestedCategoriesCreateInput {
  connect?: CategoryWhereUniqueInput[] | null;
  create?: CategoryWithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedCategoriesUpdateInput {
  connect?: CategoryWhereUniqueInput[] | null;
  update?: ArchiveNestedUpdateCategoriesUpdateInput[] | null;
  create?: CategoryWithForcedArchiveCreateInput[] | null;
  upsert?: ArchiveNestedUpsertCategoriesUpdateInput[] | null;
  delete?: CategoryWithForcedArchiveWhereUniqueInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas1CreateInput {
  create?: PhotoMetadata1WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas1UpdateInput {
  create?: PhotoMetadata1WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas2CreateInput {
  create?: PhotoMetadata2WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas2UpdateInput {
  create?: PhotoMetadata2WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas3CreateInput {
  create?: PhotoMetadata3WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas3UpdateInput {
  create?: PhotoMetadata3WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas4CreateInput {
  create?: PhotoMetadata4WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas4UpdateInput {
  create?: PhotoMetadata4WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5001CreateInput {
  create?: PhotoMetadata5001WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5001UpdateInput {
  create?: PhotoMetadata5001WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5012CreateInput {
  create?: PhotoMetadata5012WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5012UpdateInput {
  create?: PhotoMetadata5012WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5017CreateInput {
  create?: PhotoMetadata5017WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5017UpdateInput {
  create?: PhotoMetadata5017WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5019CreateInput {
  create?: PhotoMetadata5019WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5019UpdateInput {
  create?: PhotoMetadata5019WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5020CreateInput {
  create?: PhotoMetadata5020WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5020UpdateInput {
  create?: PhotoMetadata5020WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5025CreateInput {
  create?: PhotoMetadata5025WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5025UpdateInput {
  create?: PhotoMetadata5025WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5032CreateInput {
  create?: PhotoMetadata5032WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5032UpdateInput {
  create?: PhotoMetadata5032WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5033CreateInput {
  create?: PhotoMetadata5033WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5033UpdateInput {
  create?: PhotoMetadata5033WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5034CreateInput {
  create?: PhotoMetadata5034WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5034UpdateInput {
  create?: PhotoMetadata5034WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5036CreateInput {
  create?: PhotoMetadata5036WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5036UpdateInput {
  create?: PhotoMetadata5036WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5037CreateInput {
  create?: PhotoMetadata5037WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5037UpdateInput {
  create?: PhotoMetadata5037WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5038CreateInput {
  create?: PhotoMetadata5038WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5038UpdateInput {
  create?: PhotoMetadata5038WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5039CreateInput {
  create?: PhotoMetadata5039WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5039UpdateInput {
  create?: PhotoMetadata5039WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5040CreateInput {
  create?: PhotoMetadata5040WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5040UpdateInput {
  create?: PhotoMetadata5040WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5041CreateInput {
  create?: PhotoMetadata5041WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5041UpdateInput {
  create?: PhotoMetadata5041WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5043CreateInput {
  create?: PhotoMetadata5043WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5043UpdateInput {
  create?: PhotoMetadata5043WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5044CreateInput {
  create?: PhotoMetadata5044WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5044UpdateInput {
  create?: PhotoMetadata5044WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5048CreateInput {
  create?: PhotoMetadata5048WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5048UpdateInput {
  create?: PhotoMetadata5048WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5050CreateInput {
  create?: PhotoMetadata5050WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5050UpdateInput {
  create?: PhotoMetadata5050WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5051CreateInput {
  create?: PhotoMetadata5051WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5051UpdateInput {
  create?: PhotoMetadata5051WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5052CreateInput {
  create?: PhotoMetadata5052WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5052UpdateInput {
  create?: PhotoMetadata5052WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5053CreateInput {
  create?: PhotoMetadata5053WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5053UpdateInput {
  create?: PhotoMetadata5053WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5054CreateInput {
  create?: PhotoMetadata5054WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5054UpdateInput {
  create?: PhotoMetadata5054WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5055CreateInput {
  create?: PhotoMetadata5055WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5055UpdateInput {
  create?: PhotoMetadata5055WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5056CreateInput {
  create?: PhotoMetadata5056WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5056UpdateInput {
  create?: PhotoMetadata5056WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5057CreateInput {
  create?: PhotoMetadata5057WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5057UpdateInput {
  create?: PhotoMetadata5057WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5CreateInput {
  create?: PhotoMetadata5WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatas5UpdateInput {
  create?: PhotoMetadata5WithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatasCreateInput {
  connect?: PhotoMetadataWhereUniqueInput[] | null;
  create?: PhotoMetadataWithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotoMetadatasUpdateInput {
  connect?: PhotoMetadataWhereUniqueInput[] | null;
  update?: ArchiveNestedUpdatePhotoMetadatasUpdateInput[] | null;
  create?: PhotoMetadataWithForcedArchiveCreateInput[] | null;
  upsert?: ArchiveNestedUpsertPhotoMetadatasUpdateInput[] | null;
  delete?: PhotoMetadataWhereUniqueInput[] | null;
}

export interface ArchiveNestedPhotosCreateInput {
  connect?: PhotoWhereUniqueInput[] | null;
  create?: PhotoWithForcedArchiveCreateInput[] | null;
}

export interface ArchiveNestedPhotosUpdateInput {
  connect?: PhotoWhereUniqueInput[] | null;
  update?: ArchiveNestedUpdatePhotosUpdateInput[] | null;
  create?: PhotoWithForcedArchiveCreateInput[] | null;
  upsert?: ArchiveNestedUpsertPhotosUpdateInput[] | null;
  delete?: PhotoWhereUniqueInput[] | null;
}

export interface ArchiveNestedUpdateCategoriesUpdateInput {
  where: CategoryWithOptionalArchiveWhereUniqueInput;
  data: CategoryWithForcedArchiveUpdateInput;
}

export interface ArchiveNestedUpdatePhotoMetadatasUpdateInput {
  where: PhotoMetadataWhereUniqueInput;
  data: PhotoMetadataWithForcedArchiveUpdateInput;
}

export interface ArchiveNestedUpdatePhotosUpdateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoWithForcedArchiveUpdateInput;
}

export interface ArchiveNestedUpsertCategoriesUpdateInput {
  where: CategoryWithOptionalArchiveWhereUniqueInput;
  update: CategoryWithForcedArchiveUpdateInput;
  create: CategoryWithForcedArchiveCreateInput;
}

export interface ArchiveNestedUpsertPhotoMetadatasUpdateInput {
  where: PhotoMetadataWhereUniqueInput;
  update: PhotoMetadataWithForcedArchiveUpdateInput;
  create: PhotoMetadataWithForcedArchiveCreateInput;
}

export interface ArchiveNestedUpsertPhotosUpdateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoWithForcedArchiveUpdateInput;
  create: PhotoWithForcedArchiveCreateInput;
}

export interface ArchiveUpdateInput {
  categories?: ArchiveNestedCategoriesUpdateInput | null;
  photos?: ArchiveNestedPhotosUpdateInput | null;
  photoMetadatas?: ArchiveNestedPhotoMetadatasUpdateInput | null;
  photoMetadatas1?: ArchiveNestedPhotoMetadatas1UpdateInput | null;
  photoMetadatas2?: ArchiveNestedPhotoMetadatas2UpdateInput | null;
  photoMetadatas3?: ArchiveNestedPhotoMetadatas3UpdateInput | null;
  photoMetadatas4?: ArchiveNestedPhotoMetadatas4UpdateInput | null;
  photoMetadatas5?: ArchiveNestedPhotoMetadatas5UpdateInput | null;
  photoMetadatas5001?: ArchiveNestedPhotoMetadatas5001UpdateInput | null;
  photoMetadatas5012?: ArchiveNestedPhotoMetadatas5012UpdateInput | null;
  photoMetadatas5017?: ArchiveNestedPhotoMetadatas5017UpdateInput | null;
  photoMetadatas5019?: ArchiveNestedPhotoMetadatas5019UpdateInput | null;
  photoMetadatas5020?: ArchiveNestedPhotoMetadatas5020UpdateInput | null;
  photoMetadatas5025?: ArchiveNestedPhotoMetadatas5025UpdateInput | null;
  photoMetadatas5032?: ArchiveNestedPhotoMetadatas5032UpdateInput | null;
  photoMetadatas5033?: ArchiveNestedPhotoMetadatas5033UpdateInput | null;
  photoMetadatas5034?: ArchiveNestedPhotoMetadatas5034UpdateInput | null;
  photoMetadatas5036?: ArchiveNestedPhotoMetadatas5036UpdateInput | null;
  photoMetadatas5037?: ArchiveNestedPhotoMetadatas5037UpdateInput | null;
  photoMetadatas5038?: ArchiveNestedPhotoMetadatas5038UpdateInput | null;
  photoMetadatas5039?: ArchiveNestedPhotoMetadatas5039UpdateInput | null;
  photoMetadatas5040?: ArchiveNestedPhotoMetadatas5040UpdateInput | null;
  photoMetadatas5041?: ArchiveNestedPhotoMetadatas5041UpdateInput | null;
  photoMetadatas5043?: ArchiveNestedPhotoMetadatas5043UpdateInput | null;
  photoMetadatas5044?: ArchiveNestedPhotoMetadatas5044UpdateInput | null;
  photoMetadatas5048?: ArchiveNestedPhotoMetadatas5048UpdateInput | null;
  photoMetadatas5050?: ArchiveNestedPhotoMetadatas5050UpdateInput | null;
  photoMetadatas5051?: ArchiveNestedPhotoMetadatas5051UpdateInput | null;
  photoMetadatas5052?: ArchiveNestedPhotoMetadatas5052UpdateInput | null;
  photoMetadatas5053?: ArchiveNestedPhotoMetadatas5053UpdateInput | null;
  photoMetadatas5054?: ArchiveNestedPhotoMetadatas5054UpdateInput | null;
  photoMetadatas5055?: ArchiveNestedPhotoMetadatas5055UpdateInput | null;
  photoMetadatas5056?: ArchiveNestedPhotoMetadatas5056UpdateInput | null;
  photoMetadatas5057?: ArchiveNestedPhotoMetadatas5057UpdateInput | null;
}

/**
 * Filters the "Archive" nodes by specifying some conditions
 */
export interface ArchiveWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  archiveId?: number | null;
  archiveId_not?: number | null;
  archiveId_in?: number[] | null;
  archiveId_not_in?: number[] | null;
  archiveId_lt?: number | null;
  archiveId_lte?: number | null;
  archiveId_gt?: number | null;
  archiveId_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  categories_some?: CategoryWhereInput | null;
  photos_some?: PhotoWhereInput | null;
  photoMetadatas_some?: PhotoMetadataWhereInput | null;
  photoMetadatas1_some?: PhotoMetadata1WhereInput | null;
  photoMetadatas2_some?: PhotoMetadata2WhereInput | null;
  photoMetadatas3_some?: PhotoMetadata3WhereInput | null;
  photoMetadatas4_some?: PhotoMetadata4WhereInput | null;
  photoMetadatas5_some?: PhotoMetadata5WhereInput | null;
  photoMetadatas5001_some?: PhotoMetadata5001WhereInput | null;
  photoMetadatas5012_some?: PhotoMetadata5012WhereInput | null;
  photoMetadatas5017_some?: PhotoMetadata5017WhereInput | null;
  photoMetadatas5019_some?: PhotoMetadata5019WhereInput | null;
  photoMetadatas5020_some?: PhotoMetadata5020WhereInput | null;
  photoMetadatas5025_some?: PhotoMetadata5025WhereInput | null;
  photoMetadatas5032_some?: PhotoMetadata5032WhereInput | null;
  photoMetadatas5033_some?: PhotoMetadata5033WhereInput | null;
  photoMetadatas5034_some?: PhotoMetadata5034WhereInput | null;
  photoMetadatas5036_some?: PhotoMetadata5036WhereInput | null;
  photoMetadatas5037_some?: PhotoMetadata5037WhereInput | null;
  photoMetadatas5038_some?: PhotoMetadata5038WhereInput | null;
  photoMetadatas5039_some?: PhotoMetadata5039WhereInput | null;
  photoMetadatas5040_some?: PhotoMetadata5040WhereInput | null;
  photoMetadatas5041_some?: PhotoMetadata5041WhereInput | null;
  photoMetadatas5043_some?: PhotoMetadata5043WhereInput | null;
  photoMetadatas5044_some?: PhotoMetadata5044WhereInput | null;
  photoMetadatas5048_some?: PhotoMetadata5048WhereInput | null;
  photoMetadatas5050_some?: PhotoMetadata5050WhereInput | null;
  photoMetadatas5051_some?: PhotoMetadata5051WhereInput | null;
  photoMetadatas5052_some?: PhotoMetadata5052WhereInput | null;
  photoMetadatas5053_some?: PhotoMetadata5053WhereInput | null;
  photoMetadatas5054_some?: PhotoMetadata5054WhereInput | null;
  photoMetadatas5055_some?: PhotoMetadata5055WhereInput | null;
  photoMetadatas5056_some?: PhotoMetadata5056WhereInput | null;
  photoMetadatas5057_some?: PhotoMetadata5057WhereInput | null;
  AND?: ArchiveWhereInput[] | null;
  OR?: ArchiveWhereInput[] | null;
  NOT?: ArchiveWhereInput | null;
}

/**
 * Identifies exactly one "Archive" node with one of these unique values:
 * - _id
 * - id
 * - archiveId
 */
export interface ArchiveWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
  archiveId?: number | null;
}

export interface CategoryCreateInput {
  id?: string | null;
  label?: string | null;
  archive: CategoryNestedArchiveCreateInput;
  parent?: CategoryNestedParentCreateInput | null;
  children?: CategoryNestedChildrenCreateInput | null;
  photos?: CategoryNestedPhotosCreateInput | null;
}

export interface CategoryNestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: CategoryNestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: CategoryNestedUpsertArchiveCreateInput | null;
}

export interface CategoryNestedArchiveUpdateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: CategoryNestedUpdateArchiveUpdateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: CategoryNestedUpsertArchiveUpdateInput | null;
}

export interface CategoryNestedChildrenCreateInput {
  connect?: CategoryWhereUniqueInput[] | null;
  create?: CategoryWithForcedParentCreateInput[] | null;
}

export interface CategoryNestedChildrenUpdateInput {
  connect?: CategoryWhereUniqueInput[] | null;
  disconnect?: CategoryWithForcedParentWhereUniqueInput[] | null;
  update?: CategoryNestedUpdateChildrenUpdateInput[] | null;
  create?: CategoryWithForcedParentCreateInput[] | null;
  upsert?: CategoryNestedUpsertChildrenUpdateInput[] | null;
  delete?: CategoryWithForcedParentWhereUniqueInput[] | null;
}

export interface CategoryNestedParentCreateInput {
  connect?: CategoryWhereUniqueInput | null;
  update?: CategoryNestedUpdateParentCreateInput | null;
  create?: CategoryCreateInput | null;
  upsert?: CategoryNestedUpsertParentCreateInput | null;
}

export interface CategoryNestedParentUpdateInput {
  connect?: CategoryWhereUniqueInput | null;
  update?: CategoryNestedUpdateParentUpdateInput | null;
  create?: CategoryCreateInput | null;
  upsert?: CategoryNestedUpsertParentUpdateInput | null;
  disconnect?: boolean | null;
}

export interface CategoryNestedPhotosCreateInput {
  connect?: PhotoWhereUniqueInput[] | null;
  create?: PhotoWithForcedCategoryCreateInput[] | null;
}

export interface CategoryNestedPhotosUpdateInput {
  connect?: PhotoWhereUniqueInput[] | null;
  disconnect?: PhotoWhereUniqueInput[] | null;
  update?: CategoryNestedUpdatePhotosUpdateInput[] | null;
  create?: PhotoWithForcedCategoryCreateInput[] | null;
  upsert?: CategoryNestedUpsertPhotosUpdateInput[] | null;
  delete?: PhotoWhereUniqueInput[] | null;
}

export interface CategoryNestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface CategoryNestedUpdateArchiveUpdateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface CategoryNestedUpdateChildrenUpdateInput {
  where: CategoryWithOptionalParentWhereUniqueInput;
  data: CategoryWithForcedParentUpdateInput;
}

export interface CategoryNestedUpdateParentCreateInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateInput;
}

export interface CategoryNestedUpdateParentUpdateInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateInput;
}

export interface CategoryNestedUpdatePhotosUpdateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoWithForcedCategoryUpdateInput;
}

export interface CategoryNestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface CategoryNestedUpsertArchiveUpdateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface CategoryNestedUpsertChildrenUpdateInput {
  where: CategoryWithOptionalParentWhereUniqueInput;
  update: CategoryWithForcedParentUpdateInput;
  create: CategoryWithForcedParentCreateInput;
}

export interface CategoryNestedUpsertParentCreateInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateInput;
  create: CategoryCreateInput;
}

export interface CategoryNestedUpsertParentUpdateInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateInput;
  create: CategoryCreateInput;
}

export interface CategoryNestedUpsertPhotosUpdateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoWithForcedCategoryUpdateInput;
  create: PhotoWithForcedCategoryCreateInput;
}

export interface CategoryUpdateInput {
  label?: string | null;
  archive?: CategoryNestedArchiveUpdateInput | null;
  parent?: CategoryNestedParentUpdateInput | null;
  children?: CategoryNestedChildrenUpdateInput | null;
  photos?: CategoryNestedPhotosUpdateInput | null;
}

/**
 * Filters the "Category" nodes by specifying some conditions
 */
export interface CategoryWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  label?: string | null;
  label_not?: string | null;
  label_is_null?: boolean | null;
  label_in?: (string | null)[] | null;
  label_not_in?: (string | null)[] | null;
  label_contains?: string | null;
  label_not_contains?: string | null;
  label_starts_with?: string | null;
  label_not_starts_with?: string | null;
  label_ends_with?: string | null;
  label_not_ends_with?: string | null;
  label_lt?: string | null;
  label_lte?: string | null;
  label_gt?: string | null;
  label_gte?: string | null;
  archive?: ArchiveWhereInput | null;
  parent?: CategoryWhereInput | null;
  parent_is_null?: boolean | null;
  children_some?: CategoryWhereInput | null;
  photos_some?: PhotoWhereInput | null;
  AND?: CategoryWhereInput[] | null;
  OR?: CategoryWhereInput[] | null;
  NOT?: CategoryWhereInput | null;
}

/**
 * Identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - archive, label, parent
 */
export interface CategoryWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
  archive?: ArchiveWhereUniqueInput | null;
  label?: string | null;
  parent?: CategoryWhereUniqueInput | null;
}

export interface CategoryWithForcedArchiveCreateInput {
  id?: string | null;
  label?: string | null;
  parent?: CategoryNestedParentCreateInput | null;
  children?: CategoryNestedChildrenCreateInput | null;
  photos?: CategoryNestedPhotosCreateInput | null;
}

export interface CategoryWithForcedArchiveUpdateInput {
  label?: string | null;
  parent?: CategoryNestedParentUpdateInput | null;
  children?: CategoryNestedChildrenUpdateInput | null;
  photos?: CategoryNestedPhotosUpdateInput | null;
}

/**
 * Given a forced "archive", identifies exactly one "Category" node.
 */
export interface CategoryWithForcedArchiveWhereUniqueInput {
  label: string;
  parent: CategoryWhereUniqueInput;
}

export interface CategoryWithForcedParentCreateInput {
  id?: string | null;
  label?: string | null;
  archive: CategoryNestedArchiveCreateInput;
  children?: CategoryNestedChildrenCreateInput | null;
  photos?: CategoryNestedPhotosCreateInput | null;
}

export interface CategoryWithForcedParentUpdateInput {
  label?: string | null;
  archive?: CategoryNestedArchiveUpdateInput | null;
  children?: CategoryNestedChildrenUpdateInput | null;
  photos?: CategoryNestedPhotosUpdateInput | null;
}

/**
 * Given a forced "parent", identifies exactly one "Category" node.
 */
export interface CategoryWithForcedParentWhereUniqueInput {
  archive: ArchiveWhereUniqueInput;
  label: string;
}

/**
 * Given a known "archive", identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - archive (optional), label, parent
 */
export interface CategoryWithOptionalArchiveWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
  archive?: ArchiveWhereUniqueInput | null;
  label?: string | null;
  parent?: CategoryWhereUniqueInput | null;
}

/**
 * Given a known "parent", identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - archive, label, parent (optional)
 */
export interface CategoryWithOptionalParentWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
  archive?: ArchiveWhereUniqueInput | null;
  label?: string | null;
  parent?: CategoryWhereUniqueInput | null;
}

export interface GeneratePreviewSessionCreateInput {
  id?: string | null;
  startDate: GraphQL$DateTime;
  endDate: GraphQL$DateTime;
  cursor?: number | null;
  total?: number | null;
  scanned?: number | null;
  done?: number | null;
  ignored?: number | null;
  failed?: number | null;
  message?: string | null;
  filters?: string | null;
  status: GeneratePreviewSessionStatusType;
  generatePreviewTraces?: GeneratePreviewSessionNestedGeneratePreviewTracesCreateInput | null;
}

export interface GeneratePreviewSessionNestedGeneratePreviewTracesCreateInput {
  connect?: GeneratePreviewTraceWhereUniqueInput[] | null;
  create?: GeneratePreviewTraceWithForcedGeneratePreviewSessionCreateInput[] | null;
}

export interface GeneratePreviewSessionNestedGeneratePreviewTracesUpdateInput {
  connect?: GeneratePreviewTraceWhereUniqueInput[] | null;
  update?: GeneratePreviewSessionNestedUpdateGeneratePreviewTracesUpdateInput[] | null;
  create?: GeneratePreviewTraceWithForcedGeneratePreviewSessionCreateInput[] | null;
  upsert?: GeneratePreviewSessionNestedUpsertGeneratePreviewTracesUpdateInput[] | null;
  delete?: GeneratePreviewTraceWhereUniqueInput[] | null;
}

export interface GeneratePreviewSessionNestedUpdateGeneratePreviewTracesUpdateInput {
  where: GeneratePreviewTraceWhereUniqueInput;
  data: GeneratePreviewTraceWithForcedGeneratePreviewSessionUpdateInput;
}

export interface GeneratePreviewSessionNestedUpsertGeneratePreviewTracesUpdateInput {
  where: GeneratePreviewTraceWhereUniqueInput;
  update: GeneratePreviewTraceWithForcedGeneratePreviewSessionUpdateInput;
  create: GeneratePreviewTraceWithForcedGeneratePreviewSessionCreateInput;
}

export interface GeneratePreviewSessionUpdateInput {
  startDate?: GraphQL$DateTime | null;
  endDate?: GraphQL$DateTime | null;
  cursor?: number | null;
  total?: number | null;
  scanned?: number | null;
  done?: number | null;
  ignored?: number | null;
  failed?: number | null;
  message?: string | null;
  filters?: string | null;
  status?: GeneratePreviewSessionStatusType | null;
  generatePreviewTraces?: GeneratePreviewSessionNestedGeneratePreviewTracesUpdateInput | null;
}

/**
 * Filters the "GeneratePreviewSession" nodes by specifying some conditions
 */
export interface GeneratePreviewSessionWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  startDate?: GraphQL$DateTime | null;
  startDate_not?: GraphQL$DateTime | null;
  startDate_in?: GraphQL$DateTime[] | null;
  startDate_not_in?: GraphQL$DateTime[] | null;
  startDate_lt?: GraphQL$DateTime | null;
  startDate_lte?: GraphQL$DateTime | null;
  startDate_gt?: GraphQL$DateTime | null;
  startDate_gte?: GraphQL$DateTime | null;
  endDate?: GraphQL$DateTime | null;
  endDate_not?: GraphQL$DateTime | null;
  endDate_in?: GraphQL$DateTime[] | null;
  endDate_not_in?: GraphQL$DateTime[] | null;
  endDate_lt?: GraphQL$DateTime | null;
  endDate_lte?: GraphQL$DateTime | null;
  endDate_gt?: GraphQL$DateTime | null;
  endDate_gte?: GraphQL$DateTime | null;
  cursor?: number | null;
  cursor_not?: number | null;
  cursor_is_null?: boolean | null;
  cursor_in?: (number | null)[] | null;
  cursor_not_in?: (number | null)[] | null;
  cursor_lt?: number | null;
  cursor_lte?: number | null;
  cursor_gt?: number | null;
  cursor_gte?: number | null;
  total?: number | null;
  total_not?: number | null;
  total_is_null?: boolean | null;
  total_in?: (number | null)[] | null;
  total_not_in?: (number | null)[] | null;
  total_lt?: number | null;
  total_lte?: number | null;
  total_gt?: number | null;
  total_gte?: number | null;
  scanned?: number | null;
  scanned_not?: number | null;
  scanned_is_null?: boolean | null;
  scanned_in?: (number | null)[] | null;
  scanned_not_in?: (number | null)[] | null;
  scanned_lt?: number | null;
  scanned_lte?: number | null;
  scanned_gt?: number | null;
  scanned_gte?: number | null;
  done?: number | null;
  done_not?: number | null;
  done_is_null?: boolean | null;
  done_in?: (number | null)[] | null;
  done_not_in?: (number | null)[] | null;
  done_lt?: number | null;
  done_lte?: number | null;
  done_gt?: number | null;
  done_gte?: number | null;
  ignored?: number | null;
  ignored_not?: number | null;
  ignored_is_null?: boolean | null;
  ignored_in?: (number | null)[] | null;
  ignored_not_in?: (number | null)[] | null;
  ignored_lt?: number | null;
  ignored_lte?: number | null;
  ignored_gt?: number | null;
  ignored_gte?: number | null;
  failed?: number | null;
  failed_not?: number | null;
  failed_is_null?: boolean | null;
  failed_in?: (number | null)[] | null;
  failed_not_in?: (number | null)[] | null;
  failed_lt?: number | null;
  failed_lte?: number | null;
  failed_gt?: number | null;
  failed_gte?: number | null;
  message?: string | null;
  message_not?: string | null;
  message_is_null?: boolean | null;
  message_in?: (string | null)[] | null;
  message_not_in?: (string | null)[] | null;
  message_contains?: string | null;
  message_not_contains?: string | null;
  message_starts_with?: string | null;
  message_not_starts_with?: string | null;
  message_ends_with?: string | null;
  message_not_ends_with?: string | null;
  message_lt?: string | null;
  message_lte?: string | null;
  message_gt?: string | null;
  message_gte?: string | null;
  filters?: string | null;
  filters_not?: string | null;
  filters_is_null?: boolean | null;
  filters_in?: (string | null)[] | null;
  filters_not_in?: (string | null)[] | null;
  filters_contains?: string | null;
  filters_not_contains?: string | null;
  filters_starts_with?: string | null;
  filters_not_starts_with?: string | null;
  filters_ends_with?: string | null;
  filters_not_ends_with?: string | null;
  filters_lt?: string | null;
  filters_lte?: string | null;
  filters_gt?: string | null;
  filters_gte?: string | null;
  status?: GeneratePreviewSessionStatusType | null;
  status_not?: GeneratePreviewSessionStatusType | null;
  status_in?: GeneratePreviewSessionStatusType[] | null;
  status_not_in?: GeneratePreviewSessionStatusType[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  generatePreviewTraces_some?: GeneratePreviewTraceWhereInput | null;
  AND?: GeneratePreviewSessionWhereInput[] | null;
  OR?: GeneratePreviewSessionWhereInput[] | null;
  NOT?: GeneratePreviewSessionWhereInput | null;
}

/**
 * Identifies exactly one "GeneratePreviewSession" node with one of these unique values:
 * - _id
 * - id
 */
export interface GeneratePreviewSessionWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
}

export interface GeneratePreviewTraceNestedGeneratePreviewSessionCreateInput {
  connect?: GeneratePreviewSessionWhereUniqueInput | null;
  update?: GeneratePreviewTraceNestedUpdateGeneratePreviewSessionCreateInput | null;
  create?: GeneratePreviewSessionCreateInput | null;
  upsert?: GeneratePreviewTraceNestedUpsertGeneratePreviewSessionCreateInput | null;
}

export interface GeneratePreviewTraceNestedGeneratePreviewSessionUpdateInput {
  connect?: GeneratePreviewSessionWhereUniqueInput | null;
  update?: GeneratePreviewTraceNestedUpdateGeneratePreviewSessionUpdateInput | null;
  create?: GeneratePreviewSessionCreateInput | null;
  upsert?: GeneratePreviewTraceNestedUpsertGeneratePreviewSessionUpdateInput | null;
}

export interface GeneratePreviewTraceNestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: GeneratePreviewTraceNestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: GeneratePreviewTraceNestedUpsertPhotoCreateInput | null;
}

export interface GeneratePreviewTraceNestedPhotoUpdateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: GeneratePreviewTraceNestedUpdatePhotoUpdateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: GeneratePreviewTraceNestedUpsertPhotoUpdateInput | null;
}

export interface GeneratePreviewTraceNestedUpdateGeneratePreviewSessionCreateInput {
  where: GeneratePreviewSessionWhereUniqueInput;
  data: GeneratePreviewSessionUpdateInput;
}

export interface GeneratePreviewTraceNestedUpdateGeneratePreviewSessionUpdateInput {
  where: GeneratePreviewSessionWhereUniqueInput;
  data: GeneratePreviewSessionUpdateInput;
}

export interface GeneratePreviewTraceNestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface GeneratePreviewTraceNestedUpdatePhotoUpdateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface GeneratePreviewTraceNestedUpsertGeneratePreviewSessionCreateInput {
  where: GeneratePreviewSessionWhereUniqueInput;
  update: GeneratePreviewSessionUpdateInput;
  create: GeneratePreviewSessionCreateInput;
}

export interface GeneratePreviewTraceNestedUpsertGeneratePreviewSessionUpdateInput {
  where: GeneratePreviewSessionWhereUniqueInput;
  update: GeneratePreviewSessionUpdateInput;
  create: GeneratePreviewSessionCreateInput;
}

export interface GeneratePreviewTraceNestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

export interface GeneratePreviewTraceNestedUpsertPhotoUpdateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "GeneratePreviewTrace" nodes by specifying some conditions
 */
export interface GeneratePreviewTraceWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  message?: string | null;
  message_not?: string | null;
  message_is_null?: boolean | null;
  message_in?: (string | null)[] | null;
  message_not_in?: (string | null)[] | null;
  message_contains?: string | null;
  message_not_contains?: string | null;
  message_starts_with?: string | null;
  message_not_starts_with?: string | null;
  message_ends_with?: string | null;
  message_not_ends_with?: string | null;
  message_lt?: string | null;
  message_lte?: string | null;
  message_gt?: string | null;
  message_gte?: string | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  photo?: PhotoWhereInput | null;
  generatePreviewSession?: GeneratePreviewSessionWhereInput | null;
  AND?: GeneratePreviewTraceWhereInput[] | null;
  OR?: GeneratePreviewTraceWhereInput[] | null;
  NOT?: GeneratePreviewTraceWhereInput | null;
}

/**
 * Identifies exactly one "GeneratePreviewTrace" node with one of these unique values:
 * - _id
 * - id
 */
export interface GeneratePreviewTraceWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
}

export interface GeneratePreviewTraceWithForcedGeneratePreviewSessionCreateInput {
  id?: string | null;
  message?: string | null;
  photo: GeneratePreviewTraceNestedPhotoCreateInput;
}

export interface GeneratePreviewTraceWithForcedGeneratePreviewSessionUpdateInput {
  message?: string | null;
  photo?: GeneratePreviewTraceNestedPhotoUpdateInput | null;
}

export interface GeneratePreviewTraceWithForcedPhotoCreateInput {
  id?: string | null;
  message?: string | null;
  generatePreviewSession: GeneratePreviewTraceNestedGeneratePreviewSessionCreateInput;
}

export interface GeneratePreviewTraceWithForcedPhotoUpdateInput {
  message?: string | null;
  generatePreviewSession?: GeneratePreviewTraceNestedGeneratePreviewSessionUpdateInput | null;
}

export interface MetadataCreateInput {
  id?: string | null;
  name: MetadataNameEnumType;
  legacyName?: string | null;
  label: string;
  namespace: string;
  structName?: string | null;
  type: MetadataValueTypeEnum;
  photoMetadatas?: MetadataNestedPhotoMetadatasCreateInput | null;
  photoMetadatas1?: MetadataNestedPhotoMetadatas1CreateInput | null;
  photoMetadatas2?: MetadataNestedPhotoMetadatas2CreateInput | null;
  photoMetadatas3?: MetadataNestedPhotoMetadatas3CreateInput | null;
  photoMetadatas4?: MetadataNestedPhotoMetadatas4CreateInput | null;
  photoMetadatas5?: MetadataNestedPhotoMetadatas5CreateInput | null;
  photoMetadatas5001?: MetadataNestedPhotoMetadatas5001CreateInput | null;
  photoMetadatas5012?: MetadataNestedPhotoMetadatas5012CreateInput | null;
  photoMetadatas5017?: MetadataNestedPhotoMetadatas5017CreateInput | null;
  photoMetadatas5019?: MetadataNestedPhotoMetadatas5019CreateInput | null;
  photoMetadatas5020?: MetadataNestedPhotoMetadatas5020CreateInput | null;
  photoMetadatas5025?: MetadataNestedPhotoMetadatas5025CreateInput | null;
  photoMetadatas5032?: MetadataNestedPhotoMetadatas5032CreateInput | null;
  photoMetadatas5033?: MetadataNestedPhotoMetadatas5033CreateInput | null;
  photoMetadatas5034?: MetadataNestedPhotoMetadatas5034CreateInput | null;
  photoMetadatas5036?: MetadataNestedPhotoMetadatas5036CreateInput | null;
  photoMetadatas5037?: MetadataNestedPhotoMetadatas5037CreateInput | null;
  photoMetadatas5038?: MetadataNestedPhotoMetadatas5038CreateInput | null;
  photoMetadatas5039?: MetadataNestedPhotoMetadatas5039CreateInput | null;
  photoMetadatas5040?: MetadataNestedPhotoMetadatas5040CreateInput | null;
  photoMetadatas5041?: MetadataNestedPhotoMetadatas5041CreateInput | null;
  photoMetadatas5043?: MetadataNestedPhotoMetadatas5043CreateInput | null;
  photoMetadatas5044?: MetadataNestedPhotoMetadatas5044CreateInput | null;
  photoMetadatas5048?: MetadataNestedPhotoMetadatas5048CreateInput | null;
  photoMetadatas5050?: MetadataNestedPhotoMetadatas5050CreateInput | null;
  photoMetadatas5051?: MetadataNestedPhotoMetadatas5051CreateInput | null;
  photoMetadatas5052?: MetadataNestedPhotoMetadatas5052CreateInput | null;
  photoMetadatas5053?: MetadataNestedPhotoMetadatas5053CreateInput | null;
  photoMetadatas5054?: MetadataNestedPhotoMetadatas5054CreateInput | null;
  photoMetadatas5055?: MetadataNestedPhotoMetadatas5055CreateInput | null;
  photoMetadatas5056?: MetadataNestedPhotoMetadatas5056CreateInput | null;
  photoMetadatas5057?: MetadataNestedPhotoMetadatas5057CreateInput | null;
}

export interface MetadataNestedPhotoMetadatas1CreateInput {
  create?: PhotoMetadata1WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas1UpdateInput {
  create?: PhotoMetadata1WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas2CreateInput {
  create?: PhotoMetadata2WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas2UpdateInput {
  create?: PhotoMetadata2WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas3CreateInput {
  create?: PhotoMetadata3WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas3UpdateInput {
  create?: PhotoMetadata3WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas4CreateInput {
  create?: PhotoMetadata4WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas4UpdateInput {
  create?: PhotoMetadata4WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5001CreateInput {
  create?: PhotoMetadata5001WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5001UpdateInput {
  create?: PhotoMetadata5001WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5012CreateInput {
  create?: PhotoMetadata5012WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5012UpdateInput {
  create?: PhotoMetadata5012WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5017CreateInput {
  create?: PhotoMetadata5017WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5017UpdateInput {
  create?: PhotoMetadata5017WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5019CreateInput {
  create?: PhotoMetadata5019WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5019UpdateInput {
  create?: PhotoMetadata5019WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5020CreateInput {
  create?: PhotoMetadata5020WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5020UpdateInput {
  create?: PhotoMetadata5020WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5025CreateInput {
  create?: PhotoMetadata5025WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5025UpdateInput {
  create?: PhotoMetadata5025WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5032CreateInput {
  create?: PhotoMetadata5032WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5032UpdateInput {
  create?: PhotoMetadata5032WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5033CreateInput {
  create?: PhotoMetadata5033WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5033UpdateInput {
  create?: PhotoMetadata5033WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5034CreateInput {
  create?: PhotoMetadata5034WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5034UpdateInput {
  create?: PhotoMetadata5034WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5036CreateInput {
  create?: PhotoMetadata5036WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5036UpdateInput {
  create?: PhotoMetadata5036WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5037CreateInput {
  create?: PhotoMetadata5037WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5037UpdateInput {
  create?: PhotoMetadata5037WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5038CreateInput {
  create?: PhotoMetadata5038WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5038UpdateInput {
  create?: PhotoMetadata5038WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5039CreateInput {
  create?: PhotoMetadata5039WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5039UpdateInput {
  create?: PhotoMetadata5039WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5040CreateInput {
  create?: PhotoMetadata5040WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5040UpdateInput {
  create?: PhotoMetadata5040WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5041CreateInput {
  create?: PhotoMetadata5041WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5041UpdateInput {
  create?: PhotoMetadata5041WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5043CreateInput {
  create?: PhotoMetadata5043WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5043UpdateInput {
  create?: PhotoMetadata5043WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5044CreateInput {
  create?: PhotoMetadata5044WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5044UpdateInput {
  create?: PhotoMetadata5044WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5048CreateInput {
  create?: PhotoMetadata5048WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5048UpdateInput {
  create?: PhotoMetadata5048WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5050CreateInput {
  create?: PhotoMetadata5050WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5050UpdateInput {
  create?: PhotoMetadata5050WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5051CreateInput {
  create?: PhotoMetadata5051WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5051UpdateInput {
  create?: PhotoMetadata5051WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5052CreateInput {
  create?: PhotoMetadata5052WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5052UpdateInput {
  create?: PhotoMetadata5052WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5053CreateInput {
  create?: PhotoMetadata5053WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5053UpdateInput {
  create?: PhotoMetadata5053WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5054CreateInput {
  create?: PhotoMetadata5054WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5054UpdateInput {
  create?: PhotoMetadata5054WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5055CreateInput {
  create?: PhotoMetadata5055WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5055UpdateInput {
  create?: PhotoMetadata5055WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5056CreateInput {
  create?: PhotoMetadata5056WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5056UpdateInput {
  create?: PhotoMetadata5056WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5057CreateInput {
  create?: PhotoMetadata5057WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5057UpdateInput {
  create?: PhotoMetadata5057WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5CreateInput {
  create?: PhotoMetadata5WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatas5UpdateInput {
  create?: PhotoMetadata5WithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatasCreateInput {
  connect?: PhotoMetadataWhereUniqueInput[] | null;
  create?: PhotoMetadataWithForcedMetadataCreateInput[] | null;
}

export interface MetadataNestedPhotoMetadatasUpdateInput {
  connect?: PhotoMetadataWhereUniqueInput[] | null;
  update?: MetadataNestedUpdatePhotoMetadatasUpdateInput[] | null;
  create?: PhotoMetadataWithForcedMetadataCreateInput[] | null;
  upsert?: MetadataNestedUpsertPhotoMetadatasUpdateInput[] | null;
  delete?: PhotoMetadataWhereUniqueInput[] | null;
}

export interface MetadataNestedUpdatePhotoMetadatasUpdateInput {
  where: PhotoMetadataWhereUniqueInput;
  data: PhotoMetadataWithForcedMetadataUpdateInput;
}

export interface MetadataNestedUpsertPhotoMetadatasUpdateInput {
  where: PhotoMetadataWhereUniqueInput;
  update: PhotoMetadataWithForcedMetadataUpdateInput;
  create: PhotoMetadataWithForcedMetadataCreateInput;
}

export interface MetadataUpdateInput {
  name?: MetadataNameEnumType | null;
  legacyName?: string | null;
  label?: string | null;
  namespace?: string | null;
  structName?: string | null;
  type?: MetadataValueTypeEnum | null;
  photoMetadatas?: MetadataNestedPhotoMetadatasUpdateInput | null;
  photoMetadatas1?: MetadataNestedPhotoMetadatas1UpdateInput | null;
  photoMetadatas2?: MetadataNestedPhotoMetadatas2UpdateInput | null;
  photoMetadatas3?: MetadataNestedPhotoMetadatas3UpdateInput | null;
  photoMetadatas4?: MetadataNestedPhotoMetadatas4UpdateInput | null;
  photoMetadatas5?: MetadataNestedPhotoMetadatas5UpdateInput | null;
  photoMetadatas5001?: MetadataNestedPhotoMetadatas5001UpdateInput | null;
  photoMetadatas5012?: MetadataNestedPhotoMetadatas5012UpdateInput | null;
  photoMetadatas5017?: MetadataNestedPhotoMetadatas5017UpdateInput | null;
  photoMetadatas5019?: MetadataNestedPhotoMetadatas5019UpdateInput | null;
  photoMetadatas5020?: MetadataNestedPhotoMetadatas5020UpdateInput | null;
  photoMetadatas5025?: MetadataNestedPhotoMetadatas5025UpdateInput | null;
  photoMetadatas5032?: MetadataNestedPhotoMetadatas5032UpdateInput | null;
  photoMetadatas5033?: MetadataNestedPhotoMetadatas5033UpdateInput | null;
  photoMetadatas5034?: MetadataNestedPhotoMetadatas5034UpdateInput | null;
  photoMetadatas5036?: MetadataNestedPhotoMetadatas5036UpdateInput | null;
  photoMetadatas5037?: MetadataNestedPhotoMetadatas5037UpdateInput | null;
  photoMetadatas5038?: MetadataNestedPhotoMetadatas5038UpdateInput | null;
  photoMetadatas5039?: MetadataNestedPhotoMetadatas5039UpdateInput | null;
  photoMetadatas5040?: MetadataNestedPhotoMetadatas5040UpdateInput | null;
  photoMetadatas5041?: MetadataNestedPhotoMetadatas5041UpdateInput | null;
  photoMetadatas5043?: MetadataNestedPhotoMetadatas5043UpdateInput | null;
  photoMetadatas5044?: MetadataNestedPhotoMetadatas5044UpdateInput | null;
  photoMetadatas5048?: MetadataNestedPhotoMetadatas5048UpdateInput | null;
  photoMetadatas5050?: MetadataNestedPhotoMetadatas5050UpdateInput | null;
  photoMetadatas5051?: MetadataNestedPhotoMetadatas5051UpdateInput | null;
  photoMetadatas5052?: MetadataNestedPhotoMetadatas5052UpdateInput | null;
  photoMetadatas5053?: MetadataNestedPhotoMetadatas5053UpdateInput | null;
  photoMetadatas5054?: MetadataNestedPhotoMetadatas5054UpdateInput | null;
  photoMetadatas5055?: MetadataNestedPhotoMetadatas5055UpdateInput | null;
  photoMetadatas5056?: MetadataNestedPhotoMetadatas5056UpdateInput | null;
  photoMetadatas5057?: MetadataNestedPhotoMetadatas5057UpdateInput | null;
}

/**
 * Filters the "Metadata" nodes by specifying some conditions
 */
export interface MetadataWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  name?: MetadataNameEnumType | null;
  name_not?: MetadataNameEnumType | null;
  name_in?: MetadataNameEnumType[] | null;
  name_not_in?: MetadataNameEnumType[] | null;
  legacyName?: string | null;
  legacyName_not?: string | null;
  legacyName_is_null?: boolean | null;
  legacyName_in?: (string | null)[] | null;
  legacyName_not_in?: (string | null)[] | null;
  legacyName_contains?: string | null;
  legacyName_not_contains?: string | null;
  legacyName_starts_with?: string | null;
  legacyName_not_starts_with?: string | null;
  legacyName_ends_with?: string | null;
  legacyName_not_ends_with?: string | null;
  legacyName_lt?: string | null;
  legacyName_lte?: string | null;
  legacyName_gt?: string | null;
  legacyName_gte?: string | null;
  label?: string | null;
  label_not?: string | null;
  label_in?: string[] | null;
  label_not_in?: string[] | null;
  label_contains?: string | null;
  label_not_contains?: string | null;
  label_starts_with?: string | null;
  label_not_starts_with?: string | null;
  label_ends_with?: string | null;
  label_not_ends_with?: string | null;
  label_lt?: string | null;
  label_lte?: string | null;
  label_gt?: string | null;
  label_gte?: string | null;
  namespace?: string | null;
  namespace_not?: string | null;
  namespace_in?: string[] | null;
  namespace_not_in?: string[] | null;
  namespace_contains?: string | null;
  namespace_not_contains?: string | null;
  namespace_starts_with?: string | null;
  namespace_not_starts_with?: string | null;
  namespace_ends_with?: string | null;
  namespace_not_ends_with?: string | null;
  namespace_lt?: string | null;
  namespace_lte?: string | null;
  namespace_gt?: string | null;
  namespace_gte?: string | null;
  structName?: string | null;
  structName_not?: string | null;
  structName_is_null?: boolean | null;
  structName_in?: (string | null)[] | null;
  structName_not_in?: (string | null)[] | null;
  structName_contains?: string | null;
  structName_not_contains?: string | null;
  structName_starts_with?: string | null;
  structName_not_starts_with?: string | null;
  structName_ends_with?: string | null;
  structName_not_ends_with?: string | null;
  structName_lt?: string | null;
  structName_lte?: string | null;
  structName_gt?: string | null;
  structName_gte?: string | null;
  type?: MetadataValueTypeEnum | null;
  type_not?: MetadataValueTypeEnum | null;
  type_in?: MetadataValueTypeEnum[] | null;
  type_not_in?: MetadataValueTypeEnum[] | null;
  photoMetadatas_some?: PhotoMetadataWhereInput | null;
  photoMetadatas1_some?: PhotoMetadata1WhereInput | null;
  photoMetadatas2_some?: PhotoMetadata2WhereInput | null;
  photoMetadatas3_some?: PhotoMetadata3WhereInput | null;
  photoMetadatas4_some?: PhotoMetadata4WhereInput | null;
  photoMetadatas5_some?: PhotoMetadata5WhereInput | null;
  photoMetadatas5001_some?: PhotoMetadata5001WhereInput | null;
  photoMetadatas5012_some?: PhotoMetadata5012WhereInput | null;
  photoMetadatas5017_some?: PhotoMetadata5017WhereInput | null;
  photoMetadatas5019_some?: PhotoMetadata5019WhereInput | null;
  photoMetadatas5020_some?: PhotoMetadata5020WhereInput | null;
  photoMetadatas5025_some?: PhotoMetadata5025WhereInput | null;
  photoMetadatas5032_some?: PhotoMetadata5032WhereInput | null;
  photoMetadatas5033_some?: PhotoMetadata5033WhereInput | null;
  photoMetadatas5034_some?: PhotoMetadata5034WhereInput | null;
  photoMetadatas5036_some?: PhotoMetadata5036WhereInput | null;
  photoMetadatas5037_some?: PhotoMetadata5037WhereInput | null;
  photoMetadatas5038_some?: PhotoMetadata5038WhereInput | null;
  photoMetadatas5039_some?: PhotoMetadata5039WhereInput | null;
  photoMetadatas5040_some?: PhotoMetadata5040WhereInput | null;
  photoMetadatas5041_some?: PhotoMetadata5041WhereInput | null;
  photoMetadatas5043_some?: PhotoMetadata5043WhereInput | null;
  photoMetadatas5044_some?: PhotoMetadata5044WhereInput | null;
  photoMetadatas5048_some?: PhotoMetadata5048WhereInput | null;
  photoMetadatas5050_some?: PhotoMetadata5050WhereInput | null;
  photoMetadatas5051_some?: PhotoMetadata5051WhereInput | null;
  photoMetadatas5052_some?: PhotoMetadata5052WhereInput | null;
  photoMetadatas5053_some?: PhotoMetadata5053WhereInput | null;
  photoMetadatas5054_some?: PhotoMetadata5054WhereInput | null;
  photoMetadatas5055_some?: PhotoMetadata5055WhereInput | null;
  photoMetadatas5056_some?: PhotoMetadata5056WhereInput | null;
  photoMetadatas5057_some?: PhotoMetadata5057WhereInput | null;
  AND?: MetadataWhereInput[] | null;
  OR?: MetadataWhereInput[] | null;
  NOT?: MetadataWhereInput | null;
}

/**
 * Identifies exactly one "Metadata" node with one of these unique values:
 * - _id
 * - id
 * - name
 */
export interface MetadataWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
  name?: MetadataNameEnumType | null;
}

export interface PhotoCreateInput {
  id?: string | null;
  originalName?: string | null;
  contentType?: string | null;
  isUploaded?: boolean | null;
  isLegacy?: boolean | null;
  archive: PhotoNestedArchiveCreateInput;
  category?: PhotoNestedCategoryCreateInput | null;
  generatePreviewTraces?: PhotoNestedGeneratePreviewTracesCreateInput | null;
  photoMetadatas?: PhotoNestedPhotoMetadatasCreateInput | null;
  photoMetadatas1?: PhotoNestedPhotoMetadatas1CreateInput | null;
  photoMetadatas2?: PhotoNestedPhotoMetadatas2CreateInput | null;
  photoMetadatas3?: PhotoNestedPhotoMetadatas3CreateInput | null;
  photoMetadatas4?: PhotoNestedPhotoMetadatas4CreateInput | null;
  photoMetadatas5?: PhotoNestedPhotoMetadatas5CreateInput | null;
  photoMetadatas5001?: PhotoNestedPhotoMetadatas5001CreateInput | null;
  photoMetadatas5012?: PhotoNestedPhotoMetadatas5012CreateInput | null;
  photoMetadatas5017?: PhotoNestedPhotoMetadatas5017CreateInput | null;
  photoMetadatas5019?: PhotoNestedPhotoMetadatas5019CreateInput | null;
  photoMetadatas5020?: PhotoNestedPhotoMetadatas5020CreateInput | null;
  photoMetadatas5025?: PhotoNestedPhotoMetadatas5025CreateInput | null;
  photoMetadatas5032?: PhotoNestedPhotoMetadatas5032CreateInput | null;
  photoMetadatas5033?: PhotoNestedPhotoMetadatas5033CreateInput | null;
  photoMetadatas5034?: PhotoNestedPhotoMetadatas5034CreateInput | null;
  photoMetadatas5036?: PhotoNestedPhotoMetadatas5036CreateInput | null;
  photoMetadatas5037?: PhotoNestedPhotoMetadatas5037CreateInput | null;
  photoMetadatas5038?: PhotoNestedPhotoMetadatas5038CreateInput | null;
  photoMetadatas5039?: PhotoNestedPhotoMetadatas5039CreateInput | null;
  photoMetadatas5040?: PhotoNestedPhotoMetadatas5040CreateInput | null;
  photoMetadatas5041?: PhotoNestedPhotoMetadatas5041CreateInput | null;
  photoMetadatas5043?: PhotoNestedPhotoMetadatas5043CreateInput | null;
  photoMetadatas5044?: PhotoNestedPhotoMetadatas5044CreateInput | null;
  photoMetadatas5048?: PhotoNestedPhotoMetadatas5048CreateInput | null;
  photoMetadatas5050?: PhotoNestedPhotoMetadatas5050CreateInput | null;
  photoMetadatas5051?: PhotoNestedPhotoMetadatas5051CreateInput | null;
  photoMetadatas5052?: PhotoNestedPhotoMetadatas5052CreateInput | null;
  photoMetadatas5053?: PhotoNestedPhotoMetadatas5053CreateInput | null;
  photoMetadatas5054?: PhotoNestedPhotoMetadatas5054CreateInput | null;
  photoMetadatas5055?: PhotoNestedPhotoMetadatas5055CreateInput | null;
  photoMetadatas5056?: PhotoNestedPhotoMetadatas5056CreateInput | null;
  photoMetadatas5057?: PhotoNestedPhotoMetadatas5057CreateInput | null;
}

export interface PhotoMetadata1NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata1NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata1NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata1NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata1NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata1NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata1NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata1NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata1NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata1NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata1NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata1NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata1NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata1NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata1NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata1" nodes by specifying some conditions
 */
export interface PhotoMetadata1WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata1WhereInput[] | null;
  OR?: PhotoMetadata1WhereInput[] | null;
  NOT?: PhotoMetadata1WhereInput | null;
}

export interface PhotoMetadata1WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata1NestedPhotoCreateInput;
  metadata: PhotoMetadata1NestedMetadataCreateInput;
}

export interface PhotoMetadata1WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata1NestedPhotoCreateInput;
  archive: PhotoMetadata1NestedArchiveCreateInput;
}

export interface PhotoMetadata1WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata1NestedMetadataCreateInput;
  archive: PhotoMetadata1NestedArchiveCreateInput;
}

export interface PhotoMetadata2NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata2NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata2NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata2NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata2NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata2NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata2NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata2NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata2NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata2NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata2NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata2NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata2NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata2NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata2NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata2" nodes by specifying some conditions
 */
export interface PhotoMetadata2WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata2WhereInput[] | null;
  OR?: PhotoMetadata2WhereInput[] | null;
  NOT?: PhotoMetadata2WhereInput | null;
}

export interface PhotoMetadata2WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata2NestedPhotoCreateInput;
  metadata: PhotoMetadata2NestedMetadataCreateInput;
}

export interface PhotoMetadata2WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata2NestedPhotoCreateInput;
  archive: PhotoMetadata2NestedArchiveCreateInput;
}

export interface PhotoMetadata2WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata2NestedMetadataCreateInput;
  archive: PhotoMetadata2NestedArchiveCreateInput;
}

export interface PhotoMetadata3NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata3NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata3NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata3NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata3NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata3NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata3NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata3NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata3NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata3NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata3NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata3NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata3NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata3NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata3NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata3" nodes by specifying some conditions
 */
export interface PhotoMetadata3WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata3WhereInput[] | null;
  OR?: PhotoMetadata3WhereInput[] | null;
  NOT?: PhotoMetadata3WhereInput | null;
}

export interface PhotoMetadata3WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata3NestedPhotoCreateInput;
  metadata: PhotoMetadata3NestedMetadataCreateInput;
}

export interface PhotoMetadata3WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata3NestedPhotoCreateInput;
  archive: PhotoMetadata3NestedArchiveCreateInput;
}

export interface PhotoMetadata3WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata3NestedMetadataCreateInput;
  archive: PhotoMetadata3NestedArchiveCreateInput;
}

export interface PhotoMetadata4NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata4NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata4NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata4NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata4NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata4NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata4NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata4NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata4NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata4NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata4NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata4NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata4NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata4NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata4NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata4" nodes by specifying some conditions
 */
export interface PhotoMetadata4WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata4WhereInput[] | null;
  OR?: PhotoMetadata4WhereInput[] | null;
  NOT?: PhotoMetadata4WhereInput | null;
}

export interface PhotoMetadata4WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata4NestedPhotoCreateInput;
  metadata: PhotoMetadata4NestedMetadataCreateInput;
}

export interface PhotoMetadata4WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata4NestedPhotoCreateInput;
  archive: PhotoMetadata4NestedArchiveCreateInput;
}

export interface PhotoMetadata4WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata4NestedMetadataCreateInput;
  archive: PhotoMetadata4NestedArchiveCreateInput;
}

export interface PhotoMetadata5001NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5001NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5001NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5001NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5001NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5001NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5001NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5001NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5001NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5001NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5001NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5001NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5001NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5001NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5001NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5001" nodes by specifying some conditions
 */
export interface PhotoMetadata5001WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5001WhereInput[] | null;
  OR?: PhotoMetadata5001WhereInput[] | null;
  NOT?: PhotoMetadata5001WhereInput | null;
}

export interface PhotoMetadata5001WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5001NestedPhotoCreateInput;
  metadata: PhotoMetadata5001NestedMetadataCreateInput;
}

export interface PhotoMetadata5001WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5001NestedPhotoCreateInput;
  archive: PhotoMetadata5001NestedArchiveCreateInput;
}

export interface PhotoMetadata5001WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5001NestedMetadataCreateInput;
  archive: PhotoMetadata5001NestedArchiveCreateInput;
}

export interface PhotoMetadata5012NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5012NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5012NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5012NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5012NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5012NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5012NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5012NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5012NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5012NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5012NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5012NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5012NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5012NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5012NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5012" nodes by specifying some conditions
 */
export interface PhotoMetadata5012WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5012WhereInput[] | null;
  OR?: PhotoMetadata5012WhereInput[] | null;
  NOT?: PhotoMetadata5012WhereInput | null;
}

export interface PhotoMetadata5012WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5012NestedPhotoCreateInput;
  metadata: PhotoMetadata5012NestedMetadataCreateInput;
}

export interface PhotoMetadata5012WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5012NestedPhotoCreateInput;
  archive: PhotoMetadata5012NestedArchiveCreateInput;
}

export interface PhotoMetadata5012WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5012NestedMetadataCreateInput;
  archive: PhotoMetadata5012NestedArchiveCreateInput;
}

export interface PhotoMetadata5017NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5017NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5017NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5017NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5017NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5017NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5017NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5017NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5017NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5017NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5017NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5017NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5017NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5017NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5017NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5017" nodes by specifying some conditions
 */
export interface PhotoMetadata5017WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5017WhereInput[] | null;
  OR?: PhotoMetadata5017WhereInput[] | null;
  NOT?: PhotoMetadata5017WhereInput | null;
}

export interface PhotoMetadata5017WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5017NestedPhotoCreateInput;
  metadata: PhotoMetadata5017NestedMetadataCreateInput;
}

export interface PhotoMetadata5017WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5017NestedPhotoCreateInput;
  archive: PhotoMetadata5017NestedArchiveCreateInput;
}

export interface PhotoMetadata5017WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5017NestedMetadataCreateInput;
  archive: PhotoMetadata5017NestedArchiveCreateInput;
}

export interface PhotoMetadata5019NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5019NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5019NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5019NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5019NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5019NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5019NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5019NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5019NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5019NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5019NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5019NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5019NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5019NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5019NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5019" nodes by specifying some conditions
 */
export interface PhotoMetadata5019WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5019WhereInput[] | null;
  OR?: PhotoMetadata5019WhereInput[] | null;
  NOT?: PhotoMetadata5019WhereInput | null;
}

export interface PhotoMetadata5019WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5019NestedPhotoCreateInput;
  metadata: PhotoMetadata5019NestedMetadataCreateInput;
}

export interface PhotoMetadata5019WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5019NestedPhotoCreateInput;
  archive: PhotoMetadata5019NestedArchiveCreateInput;
}

export interface PhotoMetadata5019WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5019NestedMetadataCreateInput;
  archive: PhotoMetadata5019NestedArchiveCreateInput;
}

export interface PhotoMetadata5020NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5020NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5020NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5020NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5020NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5020NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5020NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5020NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5020NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5020NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5020NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5020NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5020NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5020NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5020NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5020" nodes by specifying some conditions
 */
export interface PhotoMetadata5020WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5020WhereInput[] | null;
  OR?: PhotoMetadata5020WhereInput[] | null;
  NOT?: PhotoMetadata5020WhereInput | null;
}

export interface PhotoMetadata5020WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5020NestedPhotoCreateInput;
  metadata: PhotoMetadata5020NestedMetadataCreateInput;
}

export interface PhotoMetadata5020WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5020NestedPhotoCreateInput;
  archive: PhotoMetadata5020NestedArchiveCreateInput;
}

export interface PhotoMetadata5020WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5020NestedMetadataCreateInput;
  archive: PhotoMetadata5020NestedArchiveCreateInput;
}

export interface PhotoMetadata5025NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5025NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5025NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5025NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5025NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5025NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5025NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5025NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5025NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5025NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5025NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5025NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5025NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5025NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5025NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5025" nodes by specifying some conditions
 */
export interface PhotoMetadata5025WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5025WhereInput[] | null;
  OR?: PhotoMetadata5025WhereInput[] | null;
  NOT?: PhotoMetadata5025WhereInput | null;
}

export interface PhotoMetadata5025WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5025NestedPhotoCreateInput;
  metadata: PhotoMetadata5025NestedMetadataCreateInput;
}

export interface PhotoMetadata5025WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5025NestedPhotoCreateInput;
  archive: PhotoMetadata5025NestedArchiveCreateInput;
}

export interface PhotoMetadata5025WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5025NestedMetadataCreateInput;
  archive: PhotoMetadata5025NestedArchiveCreateInput;
}

export interface PhotoMetadata5032NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5032NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5032NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5032NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5032NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5032NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5032NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5032NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5032NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5032NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5032NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5032NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5032NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5032NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5032NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5032" nodes by specifying some conditions
 */
export interface PhotoMetadata5032WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5032WhereInput[] | null;
  OR?: PhotoMetadata5032WhereInput[] | null;
  NOT?: PhotoMetadata5032WhereInput | null;
}

export interface PhotoMetadata5032WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5032NestedPhotoCreateInput;
  metadata: PhotoMetadata5032NestedMetadataCreateInput;
}

export interface PhotoMetadata5032WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5032NestedPhotoCreateInput;
  archive: PhotoMetadata5032NestedArchiveCreateInput;
}

export interface PhotoMetadata5032WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5032NestedMetadataCreateInput;
  archive: PhotoMetadata5032NestedArchiveCreateInput;
}

export interface PhotoMetadata5033NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5033NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5033NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5033NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5033NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5033NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5033NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5033NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5033NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5033NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5033NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5033NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5033NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5033NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5033NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5033" nodes by specifying some conditions
 */
export interface PhotoMetadata5033WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5033WhereInput[] | null;
  OR?: PhotoMetadata5033WhereInput[] | null;
  NOT?: PhotoMetadata5033WhereInput | null;
}

export interface PhotoMetadata5033WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5033NestedPhotoCreateInput;
  metadata: PhotoMetadata5033NestedMetadataCreateInput;
}

export interface PhotoMetadata5033WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5033NestedPhotoCreateInput;
  archive: PhotoMetadata5033NestedArchiveCreateInput;
}

export interface PhotoMetadata5033WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5033NestedMetadataCreateInput;
  archive: PhotoMetadata5033NestedArchiveCreateInput;
}

export interface PhotoMetadata5034NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5034NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5034NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5034NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5034NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5034NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5034NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5034NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5034NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5034NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5034NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5034NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5034NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5034NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5034NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5034" nodes by specifying some conditions
 */
export interface PhotoMetadata5034WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5034WhereInput[] | null;
  OR?: PhotoMetadata5034WhereInput[] | null;
  NOT?: PhotoMetadata5034WhereInput | null;
}

export interface PhotoMetadata5034WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5034NestedPhotoCreateInput;
  metadata: PhotoMetadata5034NestedMetadataCreateInput;
}

export interface PhotoMetadata5034WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5034NestedPhotoCreateInput;
  archive: PhotoMetadata5034NestedArchiveCreateInput;
}

export interface PhotoMetadata5034WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5034NestedMetadataCreateInput;
  archive: PhotoMetadata5034NestedArchiveCreateInput;
}

export interface PhotoMetadata5036NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5036NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5036NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5036NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5036NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5036NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5036NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5036NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5036NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5036NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5036NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5036NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5036NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5036NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5036NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5036" nodes by specifying some conditions
 */
export interface PhotoMetadata5036WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5036WhereInput[] | null;
  OR?: PhotoMetadata5036WhereInput[] | null;
  NOT?: PhotoMetadata5036WhereInput | null;
}

export interface PhotoMetadata5036WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5036NestedPhotoCreateInput;
  metadata: PhotoMetadata5036NestedMetadataCreateInput;
}

export interface PhotoMetadata5036WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5036NestedPhotoCreateInput;
  archive: PhotoMetadata5036NestedArchiveCreateInput;
}

export interface PhotoMetadata5036WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5036NestedMetadataCreateInput;
  archive: PhotoMetadata5036NestedArchiveCreateInput;
}

export interface PhotoMetadata5037NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5037NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5037NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5037NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5037NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5037NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5037NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5037NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5037NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5037NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5037NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5037NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5037NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5037NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5037NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5037" nodes by specifying some conditions
 */
export interface PhotoMetadata5037WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5037WhereInput[] | null;
  OR?: PhotoMetadata5037WhereInput[] | null;
  NOT?: PhotoMetadata5037WhereInput | null;
}

export interface PhotoMetadata5037WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5037NestedPhotoCreateInput;
  metadata: PhotoMetadata5037NestedMetadataCreateInput;
}

export interface PhotoMetadata5037WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5037NestedPhotoCreateInput;
  archive: PhotoMetadata5037NestedArchiveCreateInput;
}

export interface PhotoMetadata5037WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5037NestedMetadataCreateInput;
  archive: PhotoMetadata5037NestedArchiveCreateInput;
}

export interface PhotoMetadata5038NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5038NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5038NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5038NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5038NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5038NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5038NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5038NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5038NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5038NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5038NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5038NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5038NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5038NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5038NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5038" nodes by specifying some conditions
 */
export interface PhotoMetadata5038WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5038WhereInput[] | null;
  OR?: PhotoMetadata5038WhereInput[] | null;
  NOT?: PhotoMetadata5038WhereInput | null;
}

export interface PhotoMetadata5038WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5038NestedPhotoCreateInput;
  metadata: PhotoMetadata5038NestedMetadataCreateInput;
}

export interface PhotoMetadata5038WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5038NestedPhotoCreateInput;
  archive: PhotoMetadata5038NestedArchiveCreateInput;
}

export interface PhotoMetadata5038WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5038NestedMetadataCreateInput;
  archive: PhotoMetadata5038NestedArchiveCreateInput;
}

export interface PhotoMetadata5039NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5039NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5039NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5039NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5039NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5039NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5039NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5039NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5039NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5039NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5039NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5039NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5039NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5039NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5039NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5039" nodes by specifying some conditions
 */
export interface PhotoMetadata5039WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5039WhereInput[] | null;
  OR?: PhotoMetadata5039WhereInput[] | null;
  NOT?: PhotoMetadata5039WhereInput | null;
}

export interface PhotoMetadata5039WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5039NestedPhotoCreateInput;
  metadata: PhotoMetadata5039NestedMetadataCreateInput;
}

export interface PhotoMetadata5039WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5039NestedPhotoCreateInput;
  archive: PhotoMetadata5039NestedArchiveCreateInput;
}

export interface PhotoMetadata5039WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5039NestedMetadataCreateInput;
  archive: PhotoMetadata5039NestedArchiveCreateInput;
}

export interface PhotoMetadata5040NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5040NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5040NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5040NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5040NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5040NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5040NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5040NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5040NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5040NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5040NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5040NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5040NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5040NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5040NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5040" nodes by specifying some conditions
 */
export interface PhotoMetadata5040WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5040WhereInput[] | null;
  OR?: PhotoMetadata5040WhereInput[] | null;
  NOT?: PhotoMetadata5040WhereInput | null;
}

export interface PhotoMetadata5040WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5040NestedPhotoCreateInput;
  metadata: PhotoMetadata5040NestedMetadataCreateInput;
}

export interface PhotoMetadata5040WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5040NestedPhotoCreateInput;
  archive: PhotoMetadata5040NestedArchiveCreateInput;
}

export interface PhotoMetadata5040WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5040NestedMetadataCreateInput;
  archive: PhotoMetadata5040NestedArchiveCreateInput;
}

export interface PhotoMetadata5041NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5041NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5041NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5041NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5041NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5041NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5041NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5041NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5041NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5041NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5041NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5041NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5041NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5041NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5041NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5041" nodes by specifying some conditions
 */
export interface PhotoMetadata5041WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5041WhereInput[] | null;
  OR?: PhotoMetadata5041WhereInput[] | null;
  NOT?: PhotoMetadata5041WhereInput | null;
}

export interface PhotoMetadata5041WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5041NestedPhotoCreateInput;
  metadata: PhotoMetadata5041NestedMetadataCreateInput;
}

export interface PhotoMetadata5041WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5041NestedPhotoCreateInput;
  archive: PhotoMetadata5041NestedArchiveCreateInput;
}

export interface PhotoMetadata5041WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5041NestedMetadataCreateInput;
  archive: PhotoMetadata5041NestedArchiveCreateInput;
}

export interface PhotoMetadata5043NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5043NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5043NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5043NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5043NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5043NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5043NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5043NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5043NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5043NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5043NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5043NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5043NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5043NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5043NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5043" nodes by specifying some conditions
 */
export interface PhotoMetadata5043WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5043WhereInput[] | null;
  OR?: PhotoMetadata5043WhereInput[] | null;
  NOT?: PhotoMetadata5043WhereInput | null;
}

export interface PhotoMetadata5043WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5043NestedPhotoCreateInput;
  metadata: PhotoMetadata5043NestedMetadataCreateInput;
}

export interface PhotoMetadata5043WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5043NestedPhotoCreateInput;
  archive: PhotoMetadata5043NestedArchiveCreateInput;
}

export interface PhotoMetadata5043WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5043NestedMetadataCreateInput;
  archive: PhotoMetadata5043NestedArchiveCreateInput;
}

export interface PhotoMetadata5044NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5044NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5044NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5044NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5044NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5044NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5044NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5044NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5044NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5044NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5044NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5044NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5044NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5044NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5044NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5044" nodes by specifying some conditions
 */
export interface PhotoMetadata5044WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5044WhereInput[] | null;
  OR?: PhotoMetadata5044WhereInput[] | null;
  NOT?: PhotoMetadata5044WhereInput | null;
}

export interface PhotoMetadata5044WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5044NestedPhotoCreateInput;
  metadata: PhotoMetadata5044NestedMetadataCreateInput;
}

export interface PhotoMetadata5044WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5044NestedPhotoCreateInput;
  archive: PhotoMetadata5044NestedArchiveCreateInput;
}

export interface PhotoMetadata5044WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5044NestedMetadataCreateInput;
  archive: PhotoMetadata5044NestedArchiveCreateInput;
}

export interface PhotoMetadata5048NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5048NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5048NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5048NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5048NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5048NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5048NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5048NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5048NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5048NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5048NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5048NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5048NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5048NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5048NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5048" nodes by specifying some conditions
 */
export interface PhotoMetadata5048WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5048WhereInput[] | null;
  OR?: PhotoMetadata5048WhereInput[] | null;
  NOT?: PhotoMetadata5048WhereInput | null;
}

export interface PhotoMetadata5048WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5048NestedPhotoCreateInput;
  metadata: PhotoMetadata5048NestedMetadataCreateInput;
}

export interface PhotoMetadata5048WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5048NestedPhotoCreateInput;
  archive: PhotoMetadata5048NestedArchiveCreateInput;
}

export interface PhotoMetadata5048WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5048NestedMetadataCreateInput;
  archive: PhotoMetadata5048NestedArchiveCreateInput;
}

export interface PhotoMetadata5050NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5050NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5050NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5050NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5050NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5050NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5050NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5050NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5050NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5050NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5050NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5050NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5050NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5050NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5050NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5050" nodes by specifying some conditions
 */
export interface PhotoMetadata5050WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5050WhereInput[] | null;
  OR?: PhotoMetadata5050WhereInput[] | null;
  NOT?: PhotoMetadata5050WhereInput | null;
}

export interface PhotoMetadata5050WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5050NestedPhotoCreateInput;
  metadata: PhotoMetadata5050NestedMetadataCreateInput;
}

export interface PhotoMetadata5050WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5050NestedPhotoCreateInput;
  archive: PhotoMetadata5050NestedArchiveCreateInput;
}

export interface PhotoMetadata5050WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5050NestedMetadataCreateInput;
  archive: PhotoMetadata5050NestedArchiveCreateInput;
}

export interface PhotoMetadata5051NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5051NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5051NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5051NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5051NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5051NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5051NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5051NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5051NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5051NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5051NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5051NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5051NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5051NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5051NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5051" nodes by specifying some conditions
 */
export interface PhotoMetadata5051WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5051WhereInput[] | null;
  OR?: PhotoMetadata5051WhereInput[] | null;
  NOT?: PhotoMetadata5051WhereInput | null;
}

export interface PhotoMetadata5051WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5051NestedPhotoCreateInput;
  metadata: PhotoMetadata5051NestedMetadataCreateInput;
}

export interface PhotoMetadata5051WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5051NestedPhotoCreateInput;
  archive: PhotoMetadata5051NestedArchiveCreateInput;
}

export interface PhotoMetadata5051WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5051NestedMetadataCreateInput;
  archive: PhotoMetadata5051NestedArchiveCreateInput;
}

export interface PhotoMetadata5052NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5052NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5052NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5052NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5052NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5052NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5052NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5052NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5052NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5052NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5052NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5052NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5052NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5052NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5052NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5052" nodes by specifying some conditions
 */
export interface PhotoMetadata5052WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5052WhereInput[] | null;
  OR?: PhotoMetadata5052WhereInput[] | null;
  NOT?: PhotoMetadata5052WhereInput | null;
}

export interface PhotoMetadata5052WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5052NestedPhotoCreateInput;
  metadata: PhotoMetadata5052NestedMetadataCreateInput;
}

export interface PhotoMetadata5052WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5052NestedPhotoCreateInput;
  archive: PhotoMetadata5052NestedArchiveCreateInput;
}

export interface PhotoMetadata5052WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5052NestedMetadataCreateInput;
  archive: PhotoMetadata5052NestedArchiveCreateInput;
}

export interface PhotoMetadata5053NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5053NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5053NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5053NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5053NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5053NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5053NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5053NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5053NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5053NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5053NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5053NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5053NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5053NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5053NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5053" nodes by specifying some conditions
 */
export interface PhotoMetadata5053WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5053WhereInput[] | null;
  OR?: PhotoMetadata5053WhereInput[] | null;
  NOT?: PhotoMetadata5053WhereInput | null;
}

export interface PhotoMetadata5053WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5053NestedPhotoCreateInput;
  metadata: PhotoMetadata5053NestedMetadataCreateInput;
}

export interface PhotoMetadata5053WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5053NestedPhotoCreateInput;
  archive: PhotoMetadata5053NestedArchiveCreateInput;
}

export interface PhotoMetadata5053WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5053NestedMetadataCreateInput;
  archive: PhotoMetadata5053NestedArchiveCreateInput;
}

export interface PhotoMetadata5054NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5054NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5054NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5054NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5054NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5054NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5054NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5054NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5054NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5054NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5054NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5054NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5054NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5054NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5054NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5054" nodes by specifying some conditions
 */
export interface PhotoMetadata5054WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5054WhereInput[] | null;
  OR?: PhotoMetadata5054WhereInput[] | null;
  NOT?: PhotoMetadata5054WhereInput | null;
}

export interface PhotoMetadata5054WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5054NestedPhotoCreateInput;
  metadata: PhotoMetadata5054NestedMetadataCreateInput;
}

export interface PhotoMetadata5054WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5054NestedPhotoCreateInput;
  archive: PhotoMetadata5054NestedArchiveCreateInput;
}

export interface PhotoMetadata5054WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5054NestedMetadataCreateInput;
  archive: PhotoMetadata5054NestedArchiveCreateInput;
}

export interface PhotoMetadata5055NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5055NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5055NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5055NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5055NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5055NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5055NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5055NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5055NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5055NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5055NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5055NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5055NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5055NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5055NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5055" nodes by specifying some conditions
 */
export interface PhotoMetadata5055WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5055WhereInput[] | null;
  OR?: PhotoMetadata5055WhereInput[] | null;
  NOT?: PhotoMetadata5055WhereInput | null;
}

export interface PhotoMetadata5055WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5055NestedPhotoCreateInput;
  metadata: PhotoMetadata5055NestedMetadataCreateInput;
}

export interface PhotoMetadata5055WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5055NestedPhotoCreateInput;
  archive: PhotoMetadata5055NestedArchiveCreateInput;
}

export interface PhotoMetadata5055WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5055NestedMetadataCreateInput;
  archive: PhotoMetadata5055NestedArchiveCreateInput;
}

export interface PhotoMetadata5056NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5056NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5056NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5056NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5056NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5056NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5056NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5056NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5056NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5056NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5056NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5056NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5056NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5056NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5056NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5056" nodes by specifying some conditions
 */
export interface PhotoMetadata5056WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5056WhereInput[] | null;
  OR?: PhotoMetadata5056WhereInput[] | null;
  NOT?: PhotoMetadata5056WhereInput | null;
}

export interface PhotoMetadata5056WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5056NestedPhotoCreateInput;
  metadata: PhotoMetadata5056NestedMetadataCreateInput;
}

export interface PhotoMetadata5056WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5056NestedPhotoCreateInput;
  archive: PhotoMetadata5056NestedArchiveCreateInput;
}

export interface PhotoMetadata5056WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5056NestedMetadataCreateInput;
  archive: PhotoMetadata5056NestedArchiveCreateInput;
}

export interface PhotoMetadata5057NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5057NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5057NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5057NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5057NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5057NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5057NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5057NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5057NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5057NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5057NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5057NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5057NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5057NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5057NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5057" nodes by specifying some conditions
 */
export interface PhotoMetadata5057WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5057WhereInput[] | null;
  OR?: PhotoMetadata5057WhereInput[] | null;
  NOT?: PhotoMetadata5057WhereInput | null;
}

export interface PhotoMetadata5057WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5057NestedPhotoCreateInput;
  metadata: PhotoMetadata5057NestedMetadataCreateInput;
}

export interface PhotoMetadata5057WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5057NestedPhotoCreateInput;
  archive: PhotoMetadata5057NestedArchiveCreateInput;
}

export interface PhotoMetadata5057WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5057NestedMetadataCreateInput;
  archive: PhotoMetadata5057NestedArchiveCreateInput;
}

export interface PhotoMetadata5NestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadata5NestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadata5NestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadata5NestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadata5NestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadata5NestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadata5NestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadata5NestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadata5NestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadata5NestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadata5NestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadata5NestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadata5NestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadata5NestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadata5NestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata5" nodes by specifying some conditions
 */
export interface PhotoMetadata5WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5WhereInput[] | null;
  OR?: PhotoMetadata5WhereInput[] | null;
  NOT?: PhotoMetadata5WhereInput | null;
}

export interface PhotoMetadata5WithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadata5NestedPhotoCreateInput;
  metadata: PhotoMetadata5NestedMetadataCreateInput;
}

export interface PhotoMetadata5WithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadata5NestedPhotoCreateInput;
  archive: PhotoMetadata5NestedArchiveCreateInput;
}

export interface PhotoMetadata5WithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadata5NestedMetadataCreateInput;
  archive: PhotoMetadata5NestedArchiveCreateInput;
}

export interface PhotoMetadataNestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadataNestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadataNestedUpsertArchiveCreateInput | null;
}

export interface PhotoMetadataNestedArchiveUpdateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoMetadataNestedUpdateArchiveUpdateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoMetadataNestedUpsertArchiveUpdateInput | null;
}

export interface PhotoMetadataNestedMetadataCreateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadataNestedUpdateMetadataCreateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadataNestedUpsertMetadataCreateInput | null;
}

export interface PhotoMetadataNestedMetadataUpdateInput {
  connect?: MetadataWhereUniqueInput | null;
  update?: PhotoMetadataNestedUpdateMetadataUpdateInput | null;
  create?: MetadataCreateInput | null;
  upsert?: PhotoMetadataNestedUpsertMetadataUpdateInput | null;
}

export interface PhotoMetadataNestedPhotoCreateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadataNestedUpdatePhotoCreateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadataNestedUpsertPhotoCreateInput | null;
}

export interface PhotoMetadataNestedPhotoUpdateInput {
  connect?: PhotoWhereUniqueInput | null;
  update?: PhotoMetadataNestedUpdatePhotoUpdateInput | null;
  create?: PhotoCreateInput | null;
  upsert?: PhotoMetadataNestedUpsertPhotoUpdateInput | null;
}

export interface PhotoMetadataNestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadataNestedUpdateArchiveUpdateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoMetadataNestedUpdateMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadataNestedUpdateMetadataUpdateInput {
  where: MetadataWhereUniqueInput;
  data: MetadataUpdateInput;
}

export interface PhotoMetadataNestedUpdatePhotoCreateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadataNestedUpdatePhotoUpdateInput {
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}

export interface PhotoMetadataNestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadataNestedUpsertArchiveUpdateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoMetadataNestedUpsertMetadataCreateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadataNestedUpsertMetadataUpdateInput {
  where: MetadataWhereUniqueInput;
  update: MetadataUpdateInput;
  create: MetadataCreateInput;
}

export interface PhotoMetadataNestedUpsertPhotoCreateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

export interface PhotoMetadataNestedUpsertPhotoUpdateInput {
  where: PhotoWhereUniqueInput;
  update: PhotoUpdateInput;
  create: PhotoCreateInput;
}

/**
 * Filters the "PhotoMetadata" nodes by specifying some conditions
 */
export interface PhotoMetadataWhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadataWhereInput[] | null;
  OR?: PhotoMetadataWhereInput[] | null;
  NOT?: PhotoMetadataWhereInput | null;
}

/**
 * Identifies exactly one "PhotoMetadata" node.
 */
export interface PhotoMetadataWhereUniqueInput {
  id: number;
}

export interface PhotoMetadataWithForcedArchiveCreateInput {
  value?: string | null;
  photo: PhotoMetadataNestedPhotoCreateInput;
  metadata: PhotoMetadataNestedMetadataCreateInput;
}

export interface PhotoMetadataWithForcedArchiveUpdateInput {
  value?: string | null;
  photo?: PhotoMetadataNestedPhotoUpdateInput | null;
  metadata?: PhotoMetadataNestedMetadataUpdateInput | null;
}

export interface PhotoMetadataWithForcedMetadataCreateInput {
  value?: string | null;
  photo: PhotoMetadataNestedPhotoCreateInput;
  archive: PhotoMetadataNestedArchiveCreateInput;
}

export interface PhotoMetadataWithForcedMetadataUpdateInput {
  value?: string | null;
  photo?: PhotoMetadataNestedPhotoUpdateInput | null;
  archive?: PhotoMetadataNestedArchiveUpdateInput | null;
}

export interface PhotoMetadataWithForcedPhotoCreateInput {
  value?: string | null;
  metadata: PhotoMetadataNestedMetadataCreateInput;
  archive: PhotoMetadataNestedArchiveCreateInput;
}

export interface PhotoMetadataWithForcedPhotoUpdateInput {
  value?: string | null;
  metadata?: PhotoMetadataNestedMetadataUpdateInput | null;
  archive?: PhotoMetadataNestedArchiveUpdateInput | null;
}

export interface PhotoNestedArchiveCreateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoNestedUpdateArchiveCreateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoNestedUpsertArchiveCreateInput | null;
}

export interface PhotoNestedArchiveUpdateInput {
  connect?: ArchiveWhereUniqueInput | null;
  update?: PhotoNestedUpdateArchiveUpdateInput | null;
  create?: ArchiveCreateInput | null;
  upsert?: PhotoNestedUpsertArchiveUpdateInput | null;
}

export interface PhotoNestedCategoryCreateInput {
  connect?: CategoryWhereUniqueInput | null;
  update?: PhotoNestedUpdateCategoryCreateInput | null;
  create?: CategoryCreateInput | null;
  upsert?: PhotoNestedUpsertCategoryCreateInput | null;
}

export interface PhotoNestedCategoryUpdateInput {
  connect?: CategoryWhereUniqueInput | null;
  update?: PhotoNestedUpdateCategoryUpdateInput | null;
  create?: CategoryCreateInput | null;
  upsert?: PhotoNestedUpsertCategoryUpdateInput | null;
  disconnect?: boolean | null;
}

export interface PhotoNestedGeneratePreviewTracesCreateInput {
  connect?: GeneratePreviewTraceWhereUniqueInput[] | null;
  create?: GeneratePreviewTraceWithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedGeneratePreviewTracesUpdateInput {
  connect?: GeneratePreviewTraceWhereUniqueInput[] | null;
  update?: PhotoNestedUpdateGeneratePreviewTracesUpdateInput[] | null;
  create?: GeneratePreviewTraceWithForcedPhotoCreateInput[] | null;
  upsert?: PhotoNestedUpsertGeneratePreviewTracesUpdateInput[] | null;
  delete?: GeneratePreviewTraceWhereUniqueInput[] | null;
}

export interface PhotoNestedPhotoMetadatas1CreateInput {
  create?: PhotoMetadata1WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas1UpdateInput {
  create?: PhotoMetadata1WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas2CreateInput {
  create?: PhotoMetadata2WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas2UpdateInput {
  create?: PhotoMetadata2WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas3CreateInput {
  create?: PhotoMetadata3WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas3UpdateInput {
  create?: PhotoMetadata3WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas4CreateInput {
  create?: PhotoMetadata4WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas4UpdateInput {
  create?: PhotoMetadata4WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5001CreateInput {
  create?: PhotoMetadata5001WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5001UpdateInput {
  create?: PhotoMetadata5001WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5012CreateInput {
  create?: PhotoMetadata5012WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5012UpdateInput {
  create?: PhotoMetadata5012WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5017CreateInput {
  create?: PhotoMetadata5017WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5017UpdateInput {
  create?: PhotoMetadata5017WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5019CreateInput {
  create?: PhotoMetadata5019WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5019UpdateInput {
  create?: PhotoMetadata5019WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5020CreateInput {
  create?: PhotoMetadata5020WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5020UpdateInput {
  create?: PhotoMetadata5020WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5025CreateInput {
  create?: PhotoMetadata5025WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5025UpdateInput {
  create?: PhotoMetadata5025WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5032CreateInput {
  create?: PhotoMetadata5032WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5032UpdateInput {
  create?: PhotoMetadata5032WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5033CreateInput {
  create?: PhotoMetadata5033WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5033UpdateInput {
  create?: PhotoMetadata5033WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5034CreateInput {
  create?: PhotoMetadata5034WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5034UpdateInput {
  create?: PhotoMetadata5034WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5036CreateInput {
  create?: PhotoMetadata5036WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5036UpdateInput {
  create?: PhotoMetadata5036WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5037CreateInput {
  create?: PhotoMetadata5037WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5037UpdateInput {
  create?: PhotoMetadata5037WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5038CreateInput {
  create?: PhotoMetadata5038WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5038UpdateInput {
  create?: PhotoMetadata5038WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5039CreateInput {
  create?: PhotoMetadata5039WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5039UpdateInput {
  create?: PhotoMetadata5039WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5040CreateInput {
  create?: PhotoMetadata5040WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5040UpdateInput {
  create?: PhotoMetadata5040WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5041CreateInput {
  create?: PhotoMetadata5041WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5041UpdateInput {
  create?: PhotoMetadata5041WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5043CreateInput {
  create?: PhotoMetadata5043WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5043UpdateInput {
  create?: PhotoMetadata5043WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5044CreateInput {
  create?: PhotoMetadata5044WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5044UpdateInput {
  create?: PhotoMetadata5044WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5048CreateInput {
  create?: PhotoMetadata5048WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5048UpdateInput {
  create?: PhotoMetadata5048WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5050CreateInput {
  create?: PhotoMetadata5050WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5050UpdateInput {
  create?: PhotoMetadata5050WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5051CreateInput {
  create?: PhotoMetadata5051WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5051UpdateInput {
  create?: PhotoMetadata5051WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5052CreateInput {
  create?: PhotoMetadata5052WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5052UpdateInput {
  create?: PhotoMetadata5052WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5053CreateInput {
  create?: PhotoMetadata5053WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5053UpdateInput {
  create?: PhotoMetadata5053WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5054CreateInput {
  create?: PhotoMetadata5054WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5054UpdateInput {
  create?: PhotoMetadata5054WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5055CreateInput {
  create?: PhotoMetadata5055WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5055UpdateInput {
  create?: PhotoMetadata5055WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5056CreateInput {
  create?: PhotoMetadata5056WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5056UpdateInput {
  create?: PhotoMetadata5056WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5057CreateInput {
  create?: PhotoMetadata5057WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5057UpdateInput {
  create?: PhotoMetadata5057WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5CreateInput {
  create?: PhotoMetadata5WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatas5UpdateInput {
  create?: PhotoMetadata5WithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatasCreateInput {
  connect?: PhotoMetadataWhereUniqueInput[] | null;
  create?: PhotoMetadataWithForcedPhotoCreateInput[] | null;
}

export interface PhotoNestedPhotoMetadatasUpdateInput {
  connect?: PhotoMetadataWhereUniqueInput[] | null;
  update?: PhotoNestedUpdatePhotoMetadatasUpdateInput[] | null;
  create?: PhotoMetadataWithForcedPhotoCreateInput[] | null;
  upsert?: PhotoNestedUpsertPhotoMetadatasUpdateInput[] | null;
  delete?: PhotoMetadataWhereUniqueInput[] | null;
}

export interface PhotoNestedUpdateArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoNestedUpdateArchiveUpdateInput {
  where: ArchiveWhereUniqueInput;
  data: ArchiveUpdateInput;
}

export interface PhotoNestedUpdateCategoryCreateInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateInput;
}

export interface PhotoNestedUpdateCategoryUpdateInput {
  where: CategoryWhereUniqueInput;
  data: CategoryUpdateInput;
}

export interface PhotoNestedUpdateGeneratePreviewTracesUpdateInput {
  where: GeneratePreviewTraceWhereUniqueInput;
  data: GeneratePreviewTraceWithForcedPhotoUpdateInput;
}

export interface PhotoNestedUpdatePhotoMetadatasUpdateInput {
  where: PhotoMetadataWhereUniqueInput;
  data: PhotoMetadataWithForcedPhotoUpdateInput;
}

export interface PhotoNestedUpsertArchiveCreateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoNestedUpsertArchiveUpdateInput {
  where: ArchiveWhereUniqueInput;
  update: ArchiveUpdateInput;
  create: ArchiveCreateInput;
}

export interface PhotoNestedUpsertCategoryCreateInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateInput;
  create: CategoryCreateInput;
}

export interface PhotoNestedUpsertCategoryUpdateInput {
  where: CategoryWhereUniqueInput;
  update: CategoryUpdateInput;
  create: CategoryCreateInput;
}

export interface PhotoNestedUpsertGeneratePreviewTracesUpdateInput {
  where: GeneratePreviewTraceWhereUniqueInput;
  update: GeneratePreviewTraceWithForcedPhotoUpdateInput;
  create: GeneratePreviewTraceWithForcedPhotoCreateInput;
}

export interface PhotoNestedUpsertPhotoMetadatasUpdateInput {
  where: PhotoMetadataWhereUniqueInput;
  update: PhotoMetadataWithForcedPhotoUpdateInput;
  create: PhotoMetadataWithForcedPhotoCreateInput;
}

export interface PhotoUpdateInput {
  originalName?: string | null;
  contentType?: string | null;
  isUploaded?: boolean | null;
  isLegacy?: boolean | null;
  archive?: PhotoNestedArchiveUpdateInput | null;
  category?: PhotoNestedCategoryUpdateInput | null;
  generatePreviewTraces?: PhotoNestedGeneratePreviewTracesUpdateInput | null;
  photoMetadatas?: PhotoNestedPhotoMetadatasUpdateInput | null;
  photoMetadatas1?: PhotoNestedPhotoMetadatas1UpdateInput | null;
  photoMetadatas2?: PhotoNestedPhotoMetadatas2UpdateInput | null;
  photoMetadatas3?: PhotoNestedPhotoMetadatas3UpdateInput | null;
  photoMetadatas4?: PhotoNestedPhotoMetadatas4UpdateInput | null;
  photoMetadatas5?: PhotoNestedPhotoMetadatas5UpdateInput | null;
  photoMetadatas5001?: PhotoNestedPhotoMetadatas5001UpdateInput | null;
  photoMetadatas5012?: PhotoNestedPhotoMetadatas5012UpdateInput | null;
  photoMetadatas5017?: PhotoNestedPhotoMetadatas5017UpdateInput | null;
  photoMetadatas5019?: PhotoNestedPhotoMetadatas5019UpdateInput | null;
  photoMetadatas5020?: PhotoNestedPhotoMetadatas5020UpdateInput | null;
  photoMetadatas5025?: PhotoNestedPhotoMetadatas5025UpdateInput | null;
  photoMetadatas5032?: PhotoNestedPhotoMetadatas5032UpdateInput | null;
  photoMetadatas5033?: PhotoNestedPhotoMetadatas5033UpdateInput | null;
  photoMetadatas5034?: PhotoNestedPhotoMetadatas5034UpdateInput | null;
  photoMetadatas5036?: PhotoNestedPhotoMetadatas5036UpdateInput | null;
  photoMetadatas5037?: PhotoNestedPhotoMetadatas5037UpdateInput | null;
  photoMetadatas5038?: PhotoNestedPhotoMetadatas5038UpdateInput | null;
  photoMetadatas5039?: PhotoNestedPhotoMetadatas5039UpdateInput | null;
  photoMetadatas5040?: PhotoNestedPhotoMetadatas5040UpdateInput | null;
  photoMetadatas5041?: PhotoNestedPhotoMetadatas5041UpdateInput | null;
  photoMetadatas5043?: PhotoNestedPhotoMetadatas5043UpdateInput | null;
  photoMetadatas5044?: PhotoNestedPhotoMetadatas5044UpdateInput | null;
  photoMetadatas5048?: PhotoNestedPhotoMetadatas5048UpdateInput | null;
  photoMetadatas5050?: PhotoNestedPhotoMetadatas5050UpdateInput | null;
  photoMetadatas5051?: PhotoNestedPhotoMetadatas5051UpdateInput | null;
  photoMetadatas5052?: PhotoNestedPhotoMetadatas5052UpdateInput | null;
  photoMetadatas5053?: PhotoNestedPhotoMetadatas5053UpdateInput | null;
  photoMetadatas5054?: PhotoNestedPhotoMetadatas5054UpdateInput | null;
  photoMetadatas5055?: PhotoNestedPhotoMetadatas5055UpdateInput | null;
  photoMetadatas5056?: PhotoNestedPhotoMetadatas5056UpdateInput | null;
  photoMetadatas5057?: PhotoNestedPhotoMetadatas5057UpdateInput | null;
}

/**
 * Filters the "Photo" nodes by specifying some conditions
 */
export interface PhotoWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  originalName?: string | null;
  originalName_not?: string | null;
  originalName_is_null?: boolean | null;
  originalName_in?: (string | null)[] | null;
  originalName_not_in?: (string | null)[] | null;
  originalName_contains?: string | null;
  originalName_not_contains?: string | null;
  originalName_starts_with?: string | null;
  originalName_not_starts_with?: string | null;
  originalName_ends_with?: string | null;
  originalName_not_ends_with?: string | null;
  originalName_lt?: string | null;
  originalName_lte?: string | null;
  originalName_gt?: string | null;
  originalName_gte?: string | null;
  contentType?: string | null;
  contentType_not?: string | null;
  contentType_is_null?: boolean | null;
  contentType_in?: (string | null)[] | null;
  contentType_not_in?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_not_contains?: string | null;
  contentType_starts_with?: string | null;
  contentType_not_starts_with?: string | null;
  contentType_ends_with?: string | null;
  contentType_not_ends_with?: string | null;
  contentType_lt?: string | null;
  contentType_lte?: string | null;
  contentType_gt?: string | null;
  contentType_gte?: string | null;
  isUploaded?: boolean | null;
  isUploaded_not?: boolean | null;
  isUploaded_is_null?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_not_in?: (boolean | null)[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  isLegacy?: boolean | null;
  isLegacy_not?: boolean | null;
  isLegacy_is_null?: boolean | null;
  isLegacy_in?: (boolean | null)[] | null;
  isLegacy_not_in?: (boolean | null)[] | null;
  archive?: ArchiveWhereInput | null;
  category?: CategoryWhereInput | null;
  category_is_null?: boolean | null;
  generatePreviewTraces_some?: GeneratePreviewTraceWhereInput | null;
  photoMetadatas_some?: PhotoMetadataWhereInput | null;
  photoMetadatas1_some?: PhotoMetadata1WhereInput | null;
  photoMetadatas2_some?: PhotoMetadata2WhereInput | null;
  photoMetadatas3_some?: PhotoMetadata3WhereInput | null;
  photoMetadatas4_some?: PhotoMetadata4WhereInput | null;
  photoMetadatas5_some?: PhotoMetadata5WhereInput | null;
  photoMetadatas5001_some?: PhotoMetadata5001WhereInput | null;
  photoMetadatas5012_some?: PhotoMetadata5012WhereInput | null;
  photoMetadatas5017_some?: PhotoMetadata5017WhereInput | null;
  photoMetadatas5019_some?: PhotoMetadata5019WhereInput | null;
  photoMetadatas5020_some?: PhotoMetadata5020WhereInput | null;
  photoMetadatas5025_some?: PhotoMetadata5025WhereInput | null;
  photoMetadatas5032_some?: PhotoMetadata5032WhereInput | null;
  photoMetadatas5033_some?: PhotoMetadata5033WhereInput | null;
  photoMetadatas5034_some?: PhotoMetadata5034WhereInput | null;
  photoMetadatas5036_some?: PhotoMetadata5036WhereInput | null;
  photoMetadatas5037_some?: PhotoMetadata5037WhereInput | null;
  photoMetadatas5038_some?: PhotoMetadata5038WhereInput | null;
  photoMetadatas5039_some?: PhotoMetadata5039WhereInput | null;
  photoMetadatas5040_some?: PhotoMetadata5040WhereInput | null;
  photoMetadatas5041_some?: PhotoMetadata5041WhereInput | null;
  photoMetadatas5043_some?: PhotoMetadata5043WhereInput | null;
  photoMetadatas5044_some?: PhotoMetadata5044WhereInput | null;
  photoMetadatas5048_some?: PhotoMetadata5048WhereInput | null;
  photoMetadatas5050_some?: PhotoMetadata5050WhereInput | null;
  photoMetadatas5051_some?: PhotoMetadata5051WhereInput | null;
  photoMetadatas5052_some?: PhotoMetadata5052WhereInput | null;
  photoMetadatas5053_some?: PhotoMetadata5053WhereInput | null;
  photoMetadatas5054_some?: PhotoMetadata5054WhereInput | null;
  photoMetadatas5055_some?: PhotoMetadata5055WhereInput | null;
  photoMetadatas5056_some?: PhotoMetadata5056WhereInput | null;
  photoMetadatas5057_some?: PhotoMetadata5057WhereInput | null;
  AND?: PhotoWhereInput[] | null;
  OR?: PhotoWhereInput[] | null;
  NOT?: PhotoWhereInput | null;
}

/**
 * Identifies exactly one "Photo" node with one of these unique values:
 * - _id
 * - id
 */
export interface PhotoWhereUniqueInput {
  _id?: number | null;
  id?: string | null;
}

export interface PhotoWithForcedArchiveCreateInput {
  id?: string | null;
  originalName?: string | null;
  contentType?: string | null;
  isUploaded?: boolean | null;
  isLegacy?: boolean | null;
  category?: PhotoNestedCategoryCreateInput | null;
  generatePreviewTraces?: PhotoNestedGeneratePreviewTracesCreateInput | null;
  photoMetadatas?: PhotoNestedPhotoMetadatasCreateInput | null;
  photoMetadatas1?: PhotoNestedPhotoMetadatas1CreateInput | null;
  photoMetadatas2?: PhotoNestedPhotoMetadatas2CreateInput | null;
  photoMetadatas3?: PhotoNestedPhotoMetadatas3CreateInput | null;
  photoMetadatas4?: PhotoNestedPhotoMetadatas4CreateInput | null;
  photoMetadatas5?: PhotoNestedPhotoMetadatas5CreateInput | null;
  photoMetadatas5001?: PhotoNestedPhotoMetadatas5001CreateInput | null;
  photoMetadatas5012?: PhotoNestedPhotoMetadatas5012CreateInput | null;
  photoMetadatas5017?: PhotoNestedPhotoMetadatas5017CreateInput | null;
  photoMetadatas5019?: PhotoNestedPhotoMetadatas5019CreateInput | null;
  photoMetadatas5020?: PhotoNestedPhotoMetadatas5020CreateInput | null;
  photoMetadatas5025?: PhotoNestedPhotoMetadatas5025CreateInput | null;
  photoMetadatas5032?: PhotoNestedPhotoMetadatas5032CreateInput | null;
  photoMetadatas5033?: PhotoNestedPhotoMetadatas5033CreateInput | null;
  photoMetadatas5034?: PhotoNestedPhotoMetadatas5034CreateInput | null;
  photoMetadatas5036?: PhotoNestedPhotoMetadatas5036CreateInput | null;
  photoMetadatas5037?: PhotoNestedPhotoMetadatas5037CreateInput | null;
  photoMetadatas5038?: PhotoNestedPhotoMetadatas5038CreateInput | null;
  photoMetadatas5039?: PhotoNestedPhotoMetadatas5039CreateInput | null;
  photoMetadatas5040?: PhotoNestedPhotoMetadatas5040CreateInput | null;
  photoMetadatas5041?: PhotoNestedPhotoMetadatas5041CreateInput | null;
  photoMetadatas5043?: PhotoNestedPhotoMetadatas5043CreateInput | null;
  photoMetadatas5044?: PhotoNestedPhotoMetadatas5044CreateInput | null;
  photoMetadatas5048?: PhotoNestedPhotoMetadatas5048CreateInput | null;
  photoMetadatas5050?: PhotoNestedPhotoMetadatas5050CreateInput | null;
  photoMetadatas5051?: PhotoNestedPhotoMetadatas5051CreateInput | null;
  photoMetadatas5052?: PhotoNestedPhotoMetadatas5052CreateInput | null;
  photoMetadatas5053?: PhotoNestedPhotoMetadatas5053CreateInput | null;
  photoMetadatas5054?: PhotoNestedPhotoMetadatas5054CreateInput | null;
  photoMetadatas5055?: PhotoNestedPhotoMetadatas5055CreateInput | null;
  photoMetadatas5056?: PhotoNestedPhotoMetadatas5056CreateInput | null;
  photoMetadatas5057?: PhotoNestedPhotoMetadatas5057CreateInput | null;
}

export interface PhotoWithForcedArchiveUpdateInput {
  originalName?: string | null;
  contentType?: string | null;
  isUploaded?: boolean | null;
  isLegacy?: boolean | null;
  category?: PhotoNestedCategoryUpdateInput | null;
  generatePreviewTraces?: PhotoNestedGeneratePreviewTracesUpdateInput | null;
  photoMetadatas?: PhotoNestedPhotoMetadatasUpdateInput | null;
  photoMetadatas1?: PhotoNestedPhotoMetadatas1UpdateInput | null;
  photoMetadatas2?: PhotoNestedPhotoMetadatas2UpdateInput | null;
  photoMetadatas3?: PhotoNestedPhotoMetadatas3UpdateInput | null;
  photoMetadatas4?: PhotoNestedPhotoMetadatas4UpdateInput | null;
  photoMetadatas5?: PhotoNestedPhotoMetadatas5UpdateInput | null;
  photoMetadatas5001?: PhotoNestedPhotoMetadatas5001UpdateInput | null;
  photoMetadatas5012?: PhotoNestedPhotoMetadatas5012UpdateInput | null;
  photoMetadatas5017?: PhotoNestedPhotoMetadatas5017UpdateInput | null;
  photoMetadatas5019?: PhotoNestedPhotoMetadatas5019UpdateInput | null;
  photoMetadatas5020?: PhotoNestedPhotoMetadatas5020UpdateInput | null;
  photoMetadatas5025?: PhotoNestedPhotoMetadatas5025UpdateInput | null;
  photoMetadatas5032?: PhotoNestedPhotoMetadatas5032UpdateInput | null;
  photoMetadatas5033?: PhotoNestedPhotoMetadatas5033UpdateInput | null;
  photoMetadatas5034?: PhotoNestedPhotoMetadatas5034UpdateInput | null;
  photoMetadatas5036?: PhotoNestedPhotoMetadatas5036UpdateInput | null;
  photoMetadatas5037?: PhotoNestedPhotoMetadatas5037UpdateInput | null;
  photoMetadatas5038?: PhotoNestedPhotoMetadatas5038UpdateInput | null;
  photoMetadatas5039?: PhotoNestedPhotoMetadatas5039UpdateInput | null;
  photoMetadatas5040?: PhotoNestedPhotoMetadatas5040UpdateInput | null;
  photoMetadatas5041?: PhotoNestedPhotoMetadatas5041UpdateInput | null;
  photoMetadatas5043?: PhotoNestedPhotoMetadatas5043UpdateInput | null;
  photoMetadatas5044?: PhotoNestedPhotoMetadatas5044UpdateInput | null;
  photoMetadatas5048?: PhotoNestedPhotoMetadatas5048UpdateInput | null;
  photoMetadatas5050?: PhotoNestedPhotoMetadatas5050UpdateInput | null;
  photoMetadatas5051?: PhotoNestedPhotoMetadatas5051UpdateInput | null;
  photoMetadatas5052?: PhotoNestedPhotoMetadatas5052UpdateInput | null;
  photoMetadatas5053?: PhotoNestedPhotoMetadatas5053UpdateInput | null;
  photoMetadatas5054?: PhotoNestedPhotoMetadatas5054UpdateInput | null;
  photoMetadatas5055?: PhotoNestedPhotoMetadatas5055UpdateInput | null;
  photoMetadatas5056?: PhotoNestedPhotoMetadatas5056UpdateInput | null;
  photoMetadatas5057?: PhotoNestedPhotoMetadatas5057UpdateInput | null;
}

export interface PhotoWithForcedCategoryCreateInput {
  id?: string | null;
  originalName?: string | null;
  contentType?: string | null;
  isUploaded?: boolean | null;
  isLegacy?: boolean | null;
  archive: PhotoNestedArchiveCreateInput;
  generatePreviewTraces?: PhotoNestedGeneratePreviewTracesCreateInput | null;
  photoMetadatas?: PhotoNestedPhotoMetadatasCreateInput | null;
  photoMetadatas1?: PhotoNestedPhotoMetadatas1CreateInput | null;
  photoMetadatas2?: PhotoNestedPhotoMetadatas2CreateInput | null;
  photoMetadatas3?: PhotoNestedPhotoMetadatas3CreateInput | null;
  photoMetadatas4?: PhotoNestedPhotoMetadatas4CreateInput | null;
  photoMetadatas5?: PhotoNestedPhotoMetadatas5CreateInput | null;
  photoMetadatas5001?: PhotoNestedPhotoMetadatas5001CreateInput | null;
  photoMetadatas5012?: PhotoNestedPhotoMetadatas5012CreateInput | null;
  photoMetadatas5017?: PhotoNestedPhotoMetadatas5017CreateInput | null;
  photoMetadatas5019?: PhotoNestedPhotoMetadatas5019CreateInput | null;
  photoMetadatas5020?: PhotoNestedPhotoMetadatas5020CreateInput | null;
  photoMetadatas5025?: PhotoNestedPhotoMetadatas5025CreateInput | null;
  photoMetadatas5032?: PhotoNestedPhotoMetadatas5032CreateInput | null;
  photoMetadatas5033?: PhotoNestedPhotoMetadatas5033CreateInput | null;
  photoMetadatas5034?: PhotoNestedPhotoMetadatas5034CreateInput | null;
  photoMetadatas5036?: PhotoNestedPhotoMetadatas5036CreateInput | null;
  photoMetadatas5037?: PhotoNestedPhotoMetadatas5037CreateInput | null;
  photoMetadatas5038?: PhotoNestedPhotoMetadatas5038CreateInput | null;
  photoMetadatas5039?: PhotoNestedPhotoMetadatas5039CreateInput | null;
  photoMetadatas5040?: PhotoNestedPhotoMetadatas5040CreateInput | null;
  photoMetadatas5041?: PhotoNestedPhotoMetadatas5041CreateInput | null;
  photoMetadatas5043?: PhotoNestedPhotoMetadatas5043CreateInput | null;
  photoMetadatas5044?: PhotoNestedPhotoMetadatas5044CreateInput | null;
  photoMetadatas5048?: PhotoNestedPhotoMetadatas5048CreateInput | null;
  photoMetadatas5050?: PhotoNestedPhotoMetadatas5050CreateInput | null;
  photoMetadatas5051?: PhotoNestedPhotoMetadatas5051CreateInput | null;
  photoMetadatas5052?: PhotoNestedPhotoMetadatas5052CreateInput | null;
  photoMetadatas5053?: PhotoNestedPhotoMetadatas5053CreateInput | null;
  photoMetadatas5054?: PhotoNestedPhotoMetadatas5054CreateInput | null;
  photoMetadatas5055?: PhotoNestedPhotoMetadatas5055CreateInput | null;
  photoMetadatas5056?: PhotoNestedPhotoMetadatas5056CreateInput | null;
  photoMetadatas5057?: PhotoNestedPhotoMetadatas5057CreateInput | null;
}

export interface PhotoWithForcedCategoryUpdateInput {
  originalName?: string | null;
  contentType?: string | null;
  isUploaded?: boolean | null;
  isLegacy?: boolean | null;
  archive?: PhotoNestedArchiveUpdateInput | null;
  generatePreviewTraces?: PhotoNestedGeneratePreviewTracesUpdateInput | null;
  photoMetadatas?: PhotoNestedPhotoMetadatasUpdateInput | null;
  photoMetadatas1?: PhotoNestedPhotoMetadatas1UpdateInput | null;
  photoMetadatas2?: PhotoNestedPhotoMetadatas2UpdateInput | null;
  photoMetadatas3?: PhotoNestedPhotoMetadatas3UpdateInput | null;
  photoMetadatas4?: PhotoNestedPhotoMetadatas4UpdateInput | null;
  photoMetadatas5?: PhotoNestedPhotoMetadatas5UpdateInput | null;
  photoMetadatas5001?: PhotoNestedPhotoMetadatas5001UpdateInput | null;
  photoMetadatas5012?: PhotoNestedPhotoMetadatas5012UpdateInput | null;
  photoMetadatas5017?: PhotoNestedPhotoMetadatas5017UpdateInput | null;
  photoMetadatas5019?: PhotoNestedPhotoMetadatas5019UpdateInput | null;
  photoMetadatas5020?: PhotoNestedPhotoMetadatas5020UpdateInput | null;
  photoMetadatas5025?: PhotoNestedPhotoMetadatas5025UpdateInput | null;
  photoMetadatas5032?: PhotoNestedPhotoMetadatas5032UpdateInput | null;
  photoMetadatas5033?: PhotoNestedPhotoMetadatas5033UpdateInput | null;
  photoMetadatas5034?: PhotoNestedPhotoMetadatas5034UpdateInput | null;
  photoMetadatas5036?: PhotoNestedPhotoMetadatas5036UpdateInput | null;
  photoMetadatas5037?: PhotoNestedPhotoMetadatas5037UpdateInput | null;
  photoMetadatas5038?: PhotoNestedPhotoMetadatas5038UpdateInput | null;
  photoMetadatas5039?: PhotoNestedPhotoMetadatas5039UpdateInput | null;
  photoMetadatas5040?: PhotoNestedPhotoMetadatas5040UpdateInput | null;
  photoMetadatas5041?: PhotoNestedPhotoMetadatas5041UpdateInput | null;
  photoMetadatas5043?: PhotoNestedPhotoMetadatas5043UpdateInput | null;
  photoMetadatas5044?: PhotoNestedPhotoMetadatas5044UpdateInput | null;
  photoMetadatas5048?: PhotoNestedPhotoMetadatas5048UpdateInput | null;
  photoMetadatas5050?: PhotoNestedPhotoMetadatas5050UpdateInput | null;
  photoMetadatas5051?: PhotoNestedPhotoMetadatas5051UpdateInput | null;
  photoMetadatas5052?: PhotoNestedPhotoMetadatas5052UpdateInput | null;
  photoMetadatas5053?: PhotoNestedPhotoMetadatas5053UpdateInput | null;
  photoMetadatas5054?: PhotoNestedPhotoMetadatas5054UpdateInput | null;
  photoMetadatas5055?: PhotoNestedPhotoMetadatas5055UpdateInput | null;
  photoMetadatas5056?: PhotoNestedPhotoMetadatas5056UpdateInput | null;
  photoMetadatas5057?: PhotoNestedPhotoMetadatas5057UpdateInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
